
angular.module('jv.candidate.details.paginated.controller', ['jv.React.CertificateViewer'])
    .controller('jvCandidatePaginatedDetailsController', ['$scope',
        '$routeParams',
        'candidates',
        '$location',
        '$filter',
        '$compile',
        '$timeout',
        '$rootScope',
        'videoService',
        'findDefaultTemplate',
        '$window',
        'VideoInterviewInviteModalService',
        'jvTotango',
        'TemplateLoader',
        'jvCandidatesService',
        'currentUserService',
        'jvCandidatesContactFactory',
        'jvCandidatesViewfieldsFactory',
        'GAService',
        '$q',
        '$sessionStorage',
        '$log',
        'browserDetails',
        'jvCandidateDetailsUrlFAC',
        'jvCandidateDetailsConfigFAC',
        'jvCandidateDetailsProcessFormFAC', 'jvHireBroadcastSVC', 'jvHireUrlService', 'jvCandidateProfileFactory', '$sce',
        function ($scope, $routeParams, candidates, $location, $filter, $compile, $timeout, $rootScope, videoService,
            findDefaultTemplate, $window, VideoInterviewInviteModalService, jvTotango, TemplateLoader, jvCandidatesService, currentUserService,
            jvCandidatesContactFactory, jvCandidatesViewfieldsFactory, GAService, $q, $sessionStorage, $log, browserDetails,
            jvCandidateDetailsUrlFAC, jvCandidateDetailsConfigFAC, jvCandidateDetailsProcessFormFAC, jvHireBroadcastSVC, jvHireUrlService, jvCandidateProfileFactory, $sce) {
            $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
            var jvUrls = window.jvUrls,
                properties = window.properties,
                __applicationDetails = window.__applicationDetails,
                JV = window.JV;
            var REPLICATION_DELAY_MS = 5000;
            var SELECT2_LAZY_LOAD_TIME = 500;
            var fastReadTimerFn;
            //holds the application tabs list
            var applicationTabs = [];
            $scope.applicationTabs = [];
            //holds the tab names which will be assigned to currentTab upon navigation
            var summaryTab = 'summary';
            var workflowTab = 'workflow';
            angular.extend($scope, jvCandidateDetailsConfigFAC());
            //app properties
            $scope.properties = $window.properties;
            $scope.reject = {};
            $scope.message = {};
            $scope.candAppRej = {};
            $scope.quickForm = {};
            $scope.perms = {};
            $scope.fromGoto = false;
            $scope.flags.add = false;
            $scope._currentUser = currentUserService;
            $scope.addToReq = {
                selectedReq: {}
            };
            $scope.doNotSkipWFEnabled = $window.doNotSkipWFEnabled;
            $scope.isWindowsOs = browserDetails.getOSVersion() === 'Windows';
            $scope.messageForm = {
                attachments: {}
            };
            $scope.msg = {};
            $scope.note = {
                attachments: {}
            };
            $scope.loading = [];
            $rootScope.fastRead = {};
            $scope.offerMessage = {};
            $scope.isRejectOnlyAllowed = false;

            $scope.Lmargin = 0;
            $scope.isNextTabArrowActive = false;

            $scope.viewCoverPageModal = {
                visible: false,
                loading: false
            };

            $scope.locale = window._jvselfUser.locale.languageTag;
            $scope.translations = window.i18n.nativeEsig;

            $scope.canSendOffer = true;
            $scope.offerLetter = {};
            $scope.offerLetter.send = true;

            /**
             * @Method jvCheckForTabsSlider <function>
             * @Details validates if the slider arrows are required or not
             */
            var jvCheckForTabsSlider = function () {
                var jvCandAppTabs = document.getElementsByClassName('application-tabs-slider-wrapper')[0];
                if (jvCandAppTabs) {
                    $scope.isTabSliderVisible = Math.abs(jvCandAppTabs.scrollWidth - jvCandAppTabs.clientWidth) <= 1;
                    if ($scope.isTabSliderVisible) {
                        $scope.slideMargin = {
                            'margin-left': '0px'
                        };
                        $scope.isPrevTabArrowActive = false;
                    } else {
                        $scope.isPrevTabArrowActive = false;
                        $scope.isNextTabArrowActive = true;
                    }
                }
            };

            /**
             * @Method documentReady method
             * @Details calls jvCheckForTabsSlider once the DOM is ready, to show/hide arrow buttons
             */
            angular.element(document).ready(function () {
                $timeout(function () {
                    jvCheckForTabsSlider();
                }, 300);
            });

            /**
             * @Method window/browser resize event
             * @Details calls jvCheckForTabsSlider on resizing of window or browser, to show/hide arrow buttons
             */
            const resizeHandler = function () {
                jvCheckForTabsSlider();
                $scope.$apply();
            };
            if ($scope.isNewJQuery) {
                angular.element($window).on('resize', resizeHandler);
            } else {
                angular.element($window).bind('resize', resizeHandler);
            }

            // Used to check if N&M templates have been downloaded.
            $scope.flags.templatesInit = false;

            $scope.isfloatingIMWidgetLoaded = window.isfloatingIMWidgetLoaded;

            //Indicates there are draft item in the flyout
            $scope.flags.messages = {
                inDraft: false
            };
            $scope.flags.notes = {
                inDraft: false
            };
            $scope.flags.tasks = {
                inDraft: false
            };
            $scope.flags.post = {
                inDraft: false
            };
            // Holds the value of last tab that was clicked. When it has a value it also means a tab was clicked and vice-versa
            $scope.tabClicked = '';
            $scope.stickyTab = '';

            $scope.quickView = {};
            $scope.linkedInLoaded = false;
            $scope.candAppRej = {};
            $scope.appDetails = {};
            $scope.perms.APPLICATION_DISPOSITION_POST = true;
            //The scope object that will hold all the returned information from the jsonp call for the social profiles
            $scope.spDetails = {};

            // Holds the value of last nextWorkflowStep
            $scope.nextWorkflowStep = '';
            $scope.savedNotes = $scope.sentNotes = $scope.sentMessages = $scope.receivedMessages = 0;
            $scope.params = $routeParams;

            $scope.notes = $scope.messages = [];
            $scope.page = {
                count: 10
            };
            $scope.noteTemplates = [];
            $scope.messageTemplates = [];
            $scope.candFileCheck = {};

            $scope.employeeSelect = candidates.employeeSelect;
            $scope.candidateSelect = candidates.candidateSelect;
            $scope.countriesSelect = candidates.getCountries;

            $scope.jump = 'forms';
            $scope.accordion = 'feeds';
            $scope.noteQForm = {};
            $scope.postQForm = {};
            $scope.defaultNoteTemplate = '';
            var defaultPhoneData = {
                label: i18n['FROM'],
                required: true,
                errorText: i18n['JV_SENDMESSAGE_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                data: {
                    type: 'dropDown',
                    key: 'sendMsgFrom',
                    name: 'fromList',
                    optionsValues: []
                }
            };
            $scope.messageQForm = {
                templateType: 'company',
                fromPhoneData: angular.copy(defaultPhoneData)
            };
            $scope.defaultMessageTemplate = '';
            $scope.forms = [];
            $scope.fileUploaded = false;
            $scope.uploadCancel = false;
            $scope.disableSend = false;

            $scope.offerDispositionFormModal = {};

            // Scheduler - Holds all the interview schedules to be posted to the server
            $scope.schedules = {};
            // Scheduler - Holds all the interviewers scheduled for interviews - map of eid - interviewer object
            $scope.schedInterviewers = {};
            // Scheduler - cache of all the previous events scheduled.
            $scope.eventsCache = [];
            // Scheduler - Holds all the events that have been removed from the calendar(clicking on the x)
            $scope.cancelledEvents = [];
            // Scheduler - Indicates if scheduling interviews in past should be allowed or not.(Once toggled by the modal, this will always be true)
            $scope.allowPast = false;
            // Scheduler - Holds all location eids of locations added to the left panel.
            // Map over array - helps in efficient checking if the eid already exists (to prevent duplicates) + removing is a toggle or delete operator(though size is increased but that is ok in our case).
            $scope.selLocations = {};
            // Scheduler - Indicates if the events have to be re-rendered - in case of 'back to scheduler'.
            $scope.reRenderEvents = false;
            // Scheduler - Used to cache retreived user properties, right now it is only the 'profilepicurl'
            $scope.userPropsCache = {};
            // Scheduler - Holds all interview objects added to the left panel. Map of eid and the interviewer object.
            $scope.interviewers = {};
            // Scheduler - Storing the resources in free busy calendar as the user moves across the scheduler and messager.
            $scope.fbResources = {};
            // Scheduler - Cache of all gcal events in the freebusy area
            $scope.gcalEventsCache = {};
            // Scheduler - Holds the last date the scheduler was on beforemoving to the messager.
            $scope.schedDate = new Date();
            // Scheduler - Used to sort the interviewers and locations as per the added order.
            $scope.sortIndex = 0;
            // Scheduler - Indicates if the Company has enabled settings for Google Calendar communications.
            $scope.gcalAuth = false;
            // Scheduler - Indicates if the user has authorized Google calendar connections.
            $scope.gcalCompanySetup = false;
            // Scheduler - URL to direct to if a user wants to connect his/her account to Google Calendar.
            // Init to empty String so that the ng template in _sch.htm does not concat undefined
            $scope.gcalAuthUrl = '';
            // Scheduler - Indicates if it is required to install ActiveX to setup outlook(true) or if it has already been done(false).
            $scope.setUpOutlook = false;
            // Scheduler - Value returned by the BE that says if the outlook flag is enabled.
            $scope.showOutlookCalender = false;
            $scope.activeWorkflowStep = '';
            $rootScope.isFormEditInProgress = false;
            $scope.checkForPopup = true;

            /***
             * For cases when the URL has readMode=0 all subsequent calls need to have readMode=0 param
             * old code modified to make it testable
             * */
            $scope.readMode = !angular.isUndefined($routeParams.readMode) && $routeParams.readMode === '0';
            $rootScope.readMode = $scope.readMode;

            //Added this for Lazy Loading
            $scope.lazyLoading = {};
            $scope.contactInfo = {};
            $scope.profile = {};

            /*Tinymce configs*/
            $scope.disableTinymceOnStart = false;
            $scope.jvTinymceEditable = true;
            $scope.jvRenderTinymceOnLoad = true;
            $scope.jvTinymceOptions = 'styleselect | bold italic | bullist numlist | textAlign | link ';
            //Dont need the default options that we load tinymce with . The flyouts have small real estate so not all the formatting options are needed.
            $scope.jvTinymceOverrides = ' ';
            $scope.jvTinymceMenubar = false;
            $scope.customTemplatesEnabled = $window.properties.personalEmailTemplatesEnabled;

            //added check for JVIM if initalized by candidate EID
            window.isIMInitializedByEId = false;
            $scope.showLinkedProfileIntegration = false;
            $scope.LIScriptCounter = 0;
            if (angular.isDefined($window.LIRSCEnabled)) {
                $scope.linkedInRscEnabled = $window.LIRSCEnabled;
            }
            $scope.liApplyConnectEnabled = false;
            $scope.liRscEnabled = false;
            var paging = {
                list: [],
                index: false,
                cache: {}
            };

            var setProfilePhotoUrl = function () {
                $scope.profilePictureUrl = $window.jvUrls.jhire + '/action/application/' + $scope.appDetails.application.EId + '/profilePhoto' + ($scope.readMode ? '?readMode=0' : '?readMode=1') + '&' + new Date().getTime();
            };

            var navigate = function (url, hashCheck) {
                $scope.flags.loading = false;
                if (window.location.hash.indexOf(hashCheck) === -1) {
                    jvHireUrlService.loadCandidateDetailsTabByLink(url);
                }
            };

            //reset worksteps dropdown
            var resetApplicationWorkflow = function () {
                $scope.workflowStep = {
                    'elementName': $scope.i18n.WORKFLOW_STEP,
                    'reset': true
                };
            };

            //update notes count
            var updateNotesCount = function (updatedCount) {
                $scope.applicationTabs.filter(function (obj) {
                    if (obj.tabType === 'notes') {
                        obj.count = updatedCount;
                    }
                });
            };

            //update notes count
            var updateEvaluationsCount = function (updatedCount) {
                $scope.applicationTabs.filter(function (obj) {
                    if (obj.tabType === 'evaluations') {
                        obj.count = updatedCount;
                    }
                });
            };

            //update messages count
            var updateMessagesCount = function (updatedCount) {
                $scope.applicationTabs.filter(function (obj) {
                    if (obj.tabType === 'messages') {
                        obj.count = updatedCount;
                    }
                });
            };

            var getCustomMessageTemplate = function (templateId) {
                var params = {
                    replaceTokens: true
                };
                if ($scope.readMode) {
                    params.readMode = 0;
                }
                if ($scope.messageQForm.sendUser === 'false') {
                    params.sendAnonymously = true;
                }
                if ($scope.quickForm.loadAgencyTemplate === 'agency') {
                    params.sendToAgency = true;
                }
                candidates.getCustomMessageTemplate($routeParams.applicationId, templateId.SId, params).then(function (res) {
                    if (res && res.data && res.data.template) {
                        $scope.messageQForm.subject = res.data.template.subject ? res.data.template.subject : '';
                        $scope.messageQForm.content = res.data.template.body ? res.data.template.body : '';
                    }
                });
            };

            var setFlyoutTemplate = function (flyoutObject, templateObj, isReply) {
                flyoutObject.template = templateObj.eid ? templateObj : '';
                flyoutObject.subject = templateObj.subject;
                flyoutObject.content = templateObj.body || templateObj.content || '';
                if (isReply) {
                    flyoutObject.to = templateObj.from;
                } else if (templateObj.to) {
                    flyoutObject.to = templateObj.to;
                }
            };

            //reset flyout edit mode flags after user edits a note or hits cancel after edit note
            var resetFlyoutEditMode = function () {
                $scope.flyoutEditMode = false;
                $scope.flyoutObjectEId = '';
            };

            var getDefaultTabsForUser = function (appEId) {
                var applicationTabs = {
                    'summary':
                    {
                        showCondition: 'perms.APPLICATION_WORKFLOW_SUMMARY_GET',
                        tabType: 'summary',
                        href: 'summary/' + appEId,
                        tabOrder: 1
                    },
                    'crm':
                    {
                        showCondition: 'perms.APPLICATION_EVOLVE_SOURCE_RECRUITER',
                        tabType: 'crm',
                        href: 'crm/' + appEId,
                        tabOrder: 2
                    },
                    'application':
                    {
                        showCondition: $scope.perms.APPLICATION_RESOURCE_GET || $scope.perms.PREINTERVIEW_FORM_GET || $scope.perms.SHARE_POST,
                        tabType: 'application',
                        href: 'application/' + appEId,
                        tabOrder: 3
                    },
                    'videos':
                    {
                        showCondition: 'perms.VIDEO_LIST && properties.videoEnabled',

                        tabType: 'videos',
                        href: 'videos/' + appEId,
                        count: $scope.totalVideoCompletedQuestionnaireCount || 0,
                        tabOrder: 4
                    },
                    'workflow':
                    {
                        showCondition: 'perms.APPLICATION_WORKFLOW_SUMMARY_GET',
                        tabType: 'workflow',
                        href: 'workflow/' + appEId,
                        tabOrder: 5

                    },
                    'evaluations':
                    {
                        showCondition: 'perms.VIDEO_ALL_EVALUATIONS || perms.INTERVIEW_EVALUATIONS_GET',
                        tabType: 'evaluations',
                        href: 'evaluations/' + appEId,
                        count: $scope.submittedEvaluationsCount,
                        tabOrder: 6
                    },
                    'notes':
                    {
                        showCondition: 'perms.APPLICATION_NOTES_GET',
                        tabType: 'notes',
                        href: 'notes/' + appEId,
                        count: $scope.savedNotes + $scope.sentNotes,
                        tabOrder: 7
                    },
                    'messages':
                    {
                        showCondition: 'perms.APPLICATION_MESSAGES_GET',
                        tabType: 'messages',
                        href: 'messages/' + appEId,
                        count: $scope.receivedMessages + $scope.sentMessages,
                        tabOrder: 8
                    },
                    'intelligentMessaging':
                    {
                        showCondition: 'perms.APPLICATION_IM_POST',
                        tabType: 'intelligentMessaging',
                        href: 'intelligentMessaging/' + appEId,
                        tabOrder: 9
                    },
                    'tasks':
                    {
                        showCondition: 'perms.APPLICATION_TASKS_GET',
                        tabType: 'tasks',
                        href: 'tasks/' + appEId,
                        tabOrder: 10
                    },
                    'feed':
                    {
                        showCondition: 'perms.APPLICATION_FEEDS_GET',
                        tabType: 'feed',
                        href: 'feed/' + appEId,
                        tabOrder: 11
                    },
                    'activity':
                    {
                        showCondition: 'perms.APPLICATION_ACTIVITY_FEED_GET',
                        tabType: 'activity',
                        href: 'activity/' + appEId,
                        tabOrder: 12
                    }

                };
                return applicationTabs;
            };

            //utility to get tab object from url, name
            var getTabObject = function (tabUrl, tabType) {
                var tabObj = {};
                var tabSet = getDefaultTabsForUser();
                angular.forEach(tabSet, function (tab) {
                    if (tabUrl && '#/' + tab.href === tabUrl) {
                        tabObj = tab;
                    }
                    else if (tabType && tab.tabType === tabType) {
                        tabObj = tab;
                    }
                });
                return tabObj;
            };

            var getInterviewDateAndActions = function (interviews) {
                var temp = [];
                var dateAndActions = {
                    showActions: {},
                    dateRangeArr: {}
                };

                angular.forEach(interviews, function (interview) {
                    //To show action links based on interview state
                    if (!interview.completed) {
                        dateAndActions.showActions[interview.groupId] = true;
                    }
                    //interview schedule date
                    if (interview.scheduleUtc && (!interview.interviewStatus || interview.interviewStatus !== 'Canceled')) {
                        if (temp.length === 0) {
                            temp.push($filter('localeDateTime')(interview.scheduleUtc, 'shortDate', 'MM/dd/yyyy'));
                        } else if (temp[temp.length - 1] !== $filter('localeDateTime')(interview.scheduleUtc, 'shortDate', 'MM/dd/yyyy')) {
                            temp.push($filter('localeDateTime')(interview.scheduleUtc, 'shortDate', 'MM/dd/yyyy'));
                        }
                    }
                    dateAndActions.dateRangeArr[interview.groupId] = temp.join(' - ');
                });

                return dateAndActions;
            };

            var groupingInterviewMsgs = function (interviewMessages) {
                var interviewMsgs = {};
                angular.forEach(interviewMessages, function (data) {
                    if (data.groupId || data.groupId === 0) {
                        if (!interviewMsgs[data.groupId]) {
                            interviewMsgs[data.groupId] = [];
                        }
                        interviewMsgs[data.groupId].push(data.message.sentDate);
                    }
                });

                return interviewMsgs;
            };

            $scope.toggleShowAllFields = function () {
                $scope.showAllFields = !$scope.showAllFields;
                $window.localStorage.setItem('candidateDetails.showAllFields', $scope.showAllFields);
            };

            $scope.toggleShowAllApplicationFields = function () {
                $scope.showAllApplicationFields = !$scope.showAllApplicationFields;
                $window.localStorage.setItem('candidateDetails.showAllApplicationFields', $scope.showAllApplicationFields);
            };

            jvHireBroadcastSVC.subscribe('update_identity_module', function () {
                $scope.getApplicationDetails(true);
                setProfilePhotoUrl();
            });

            jvHireBroadcastSVC.subscribe('candidate_view_fields_factory_updated', function () {
                jvCandidatesViewfieldsFactory.getCandidateViewFields($routeParams.applicationId, null, function (data) {
                    angular.extend($scope.contactInfo, $scope.massageContactInfoDetails(data));
                }, true);
            });
            $scope.showAllFields = JSON.parse($window.localStorage.getItem('candidateDetails.showAllFields')) || false;
            $scope.showAllApplicationFields = JSON.parse($window.localStorage.getItem('candidateDetails.showAllApplicationFields')) || false;

            //emitting an event to trigger modals
            $scope.triggerModal = function (showCondition, data) {
                $rootScope.$emit(showCondition, data);
            };
            $scope.hashCodeConvert = function (str) {
                let hash = 0;
                for (let i = 0; i < str.length; i++) {
                   // eslint-disable-next-line
                    hash = (hash * 31 + str.charCodeAt(i)) | 0;
                }
                return hash;
            };
            $scope.crmProfileRedirect = function (candidateEId) {
               const crmProfileUrl = $('#crmLinkInput').val();
                if (crmProfileUrl && candidateEId) {
                    window.open(crmProfileUrl + '/' + candidateEId + $scope.hashCodeConvert(candidateEId), '_blank');
                }
            };

            //select2 url for workflow steps
            $scope.workflowStepsUrl = jvCandidateDetailsUrlFAC.getWorkflowStepUrl.format($routeParams.applicationId);

            //Actions Drop down config Need to remove post candidate centric
            $scope.actionsDropDownConfig = [
                {
                    type: 'a',
                    showCondition: 'perms.APPLICATION_ADD_TO_REQUISITION_POST',
                    classNames: ['icon', 'icon-add', 'marginRight10', 'width-inherit', 'jv-add-req'],
                    clickEvent: 'triggerModal(\'showAddToReqModal\',{appIds:[applicationId],name:appDetails.application.candidate,list:allApplications})',
                    text: $scope.i18n['ADD_TO_REQUISITION']
                },
                {
                    type: 'a',
                    showCondition: 'perms.APPLICATION_MOVE_CANDIDATE',
                    classNames: ['icon', 'icon-move-horizontal', 'marginRight10', 'width-inherit', 'jv-move-cand'],
                    clickEvent: 'triggerModal(\'showMoveCandidateModal\',{appIds:[applicationId],name:appDetails.application.candidate})',
                    text: $scope.i18n['APPLICANT_APPLICANTGRID_MOVE_CANDIDATE']
                },
                {
                    type: 'a',
                    showCondition: 'perms.APPLICATION_SEND_JOBVITE_POST && appDetails.application.job.sendJobvite',
                    classNames: ['icon', 'icon-share', 'marginRight10', 'width-inherit', 'jv-send-jobvite'],
                    clickEvent: 'redirectToSendJobvite()',
                    text: $scope.i18n['SEND_JOBVITE']
                },
                {
                    type: 'a',
                    showCondition: 'perms.APPLICATION_DELETE',
                    classNames: ['icon', 'icon-delete', 'marginRight10', 'width-inherit', 'jv-app-delete'],
                    clickEvent: 'triggerModal(\'showDeleteCandidateModal\',{appIds:[applicationId],name:appDetails.application.candidate})',
                    text: $scope.i18n['I18N_CANDIDATE_DELETE']
                },
                {
                    type: 'a',
                    showCondition: 'perms.SHARE_APPLICATION_DETAILS_ACTION',
                    classNames: ['icon', 'icon-share-contact', 'marginRight10', 'width-inherit', 'jv-share-app'],
                    clickEvent: 'triggerModal(\'showShareApplicationModal\',{appIds:[applicationId],name:appDetails.application.candidate})',
                    text: $scope.i18n['I18N_SHARE'] + ' ' + $scope.i18n['application']
                } ,
                {
                    type: 'a',
                    showCondition: 'perms.APPLICATION_EVOLVE_SOURCE_RECRUITER',
                    classNames: ['icon', 'icon-contact', 'marginRight10', 'width-inherit', 'jv-crm-cand'],
                    clickEvent: 'crmProfileRedirect(appDetails.application.candidate.EId)',
                    text: $scope.i18n['I18N_JV_CRM_REDIRECT']
                }
            ];

            $scope.primaryActions = [];
            $scope.secondaryActions = [];
            $scope.otherPrimaryActions = [];

            //used to toggle the more dropdown
            $scope.toggleMoreActions = function (condition) {
                $scope.showMoreActions = condition;
            };

            //used to toggle the job/application dropdown
            $scope.toggleApplication = function (condition) {
                if ($scope.applicationList.length > 1) {
                    $scope.showApplicationDropdown = condition;
                }
            };

            //For the DEMO. Need to make this is a directive.
            $scope.workflowUpdates = [];

            $scope.getWorkflowUpdates = function (index, applicationId) {
                var args = {
                    applicationId: applicationId,
                    readMode: $scope.readMode || $scope.fastRead.summary ? 0 : 1
                };

                jvCandidatesService.getWorkflowUpdates(args, function (response) {
                    $scope.workflowUpdates[index] = response.data.applicationWorkflowUpdates;
                });
            };

            $scope.numberOfSteps = function () {
                //4 steps right now.
                return new Array(4);
            };

            //Flags to show/hide edit icon for workHistory and Education
            $scope.enableWorkEdit = false;
            $scope.enableEducationEdit = false;
            //flag used to enable/disable edit on work History / education
            $timeout(function () {
                $scope.canEditProfile = $scope.perms.APPLICATION_APPLICATIONS_DETAILS_EDIT_POST || false;
            });
            //toggleWorkEducationEdit
            $scope.enableProfileEdit = function (objectType) {
                if (objectType === 'workHistory') {
                    $scope.$broadcast('editWorkHistory');
                }
                if (objectType === 'education') {
                    $scope.$broadcast('editEducationHistory');
                }
            };

            //Render profile data inside the identity module
            $scope.renderProfileData = function (data) {
                if (!data) {
                    return;
                }
                if (data.education) {
                    var educationList = [];
                    angular.forEach(data.education, function (education) {
                        educationList.push(education['collegeName']);
                    });
                    $scope.profile.education = educationList.join(', ');
                }
                if (data.workHistory) {
                    var workHistoryList = [];
                    angular.forEach(data.workHistory, function (workHistory) {
                        workHistoryList.push(workHistory['companyName']);
                    });
                    $scope.profile.employment = workHistoryList.join(', ');
                }
                $scope.profile.userEdited = data.userEdited;
                $window.__applicationDetails.workEducationData = data;
            };
            var data = {
                subscriber: $scope.renderProfileData
            };
            //use broadcast to send this to the profile controller which is the child of can.details
            //profileCtrlLoaded event is to make sure profile history contoller is loaded
            //removed the condition as it blocked the work and education history view on switching tabs
            $scope.$on('profileCtrlLoaded', function () {
                $scope.profile = {};
                $rootScope.$broadcast('getProfileHistory', data);
            });

            var createButtonObject = function (actionObj) {
                var buttonObj = {
                    type: 'a',
                    hideCondition: '(workflowStepsMap[actionObj.nextStateEId].itemId == 4 && !perms.SEND_OFFER_POST) ||(workflowStepsMap[actionObj.nextStateEId].itemId == 1 && !perms.APPLICATION_OFFER_FORM_GET) || (workflowStepsMap[actionObj.nextStateEId].itemId == 9 && !perms.APPROVE_CANDIDATE_POST) ||(workflowStepsMap[actionObj.nextStateEId].itemId == 10 && !perms.APPROVE_CANDIDATE_POST) || (workflowStepsMap[actionObj.nextStateEId].itemId == 7 && !perms.APPLICATION_REJECT_FORM_GET) ||(workflowStepsMap[actionObj.nextStateEId].itemId == 5 && !perms.APPLICATION_ADD_EDIT_HIRE_POST) || (workflowStepsMap[actionObj.nextStateEId].itemId == 11 && !perms.APPLICATION_GENERATE_OFFER_GET)',
                    classNames: ['marginRight10', 'width-inherit', 'btn-hollow', 'workflow-buttons'],
                    //TODO : Find a way to send actionObj
                    clickEvent: 'trigger(\'' + actionObj.nextStateEId + '\',\'' + actionObj.stateEId + '\',' + actionObj.kind + ')',
                    text: actionObj.name
                };
                return buttonObj;
            };
            //Construct workflowActions buttons
            var getPrimaryActions = function (actionObjects, start, end) {
                var actionsList = [];
                //we want only 3 primary actions to be shown . If more than 3 they go under secondary actions list
                //This isRejectOnlyAllowed is added as a fix for SUPPORT-336. We are checking that if workflow change is not enabld and only reject is enabled, this is true
                $scope.isRejectOnlyAllowed = angular.isDefined($scope.perms) && !$scope.perms.APPLICATION_WORKFLOW_ACTIONS_POST && $scope.perms.APPLICATION_REJECT_FORM_GET;
                //Just to not send undefined in isRejectOnlyAllowed
                if ($scope.isRejectOnlyAllowed) {
                    var pos = actionObjects.findIndex(function (i) { return i.name === 'Reject'; });
                    if (pos !== -1) {
                        actionsList.push(createButtonObject(actionObjects[pos]));
                    }
                } else {
                    for (var i = start - 1; i < end; i++) {
                        var actionObj = actionObjects[i];
                        actionsList.push(createButtonObject(actionObj));
                    }
                }
                return actionsList;
            };
            $scope.redirectToSendJobvite = function () {
                var url = $window.jvUrls.source + '/source/share/shareJobvite.html?jobIds=' + $scope.appDetails.application.job.EId + '&tabId=1';
                location.href = url;
            };

            $scope.addLoading = function (name) {
                name = name || 'default';
                if ($.inArray(name, $scope.loading) < 0) {
                    $scope.loading.push(name);
                }
                if (!$scope.flags.loading) {
                    $scope.flags.loading = true;
                }
            };
            $scope.removeLoading = function () {
                if ($scope.loading.length > 0) {
                    $scope.loading.pop();
                    if ($scope.flags.loading && $scope.loading.length === 0) {
                        $scope.flags.loading = false;
                    }
                }
            };

            //This needs to be here because the modal controller does not get initialized on the details page.
            $scope.$on('showScheduler', function (event, data) {
                if (data) {
                    var applicationId = data.applicationId;
                    var mode = data.mode;
                    var stateId = data.stateId;
                    var jobId = data.jobId;
                    jvCandidatesService.redirectToScheduler(data, function (response) {
                        if (response && response.status === 200) {
                            var step = response.data.workflowActivities;
                            var hasAdvancedSchedulerEnabled = step.model.advancedSchedulerEnabled;
                            var interviewType = step.workflowElementInfo.metaModel.interviewStatus;

                            if ($window.enableSelfScheduling && mode !== 'modifyMessage' && interviewType === 'Schedule') {
                                jvHireUrlService.navigateToCandidateSelfScheduler(applicationId, stateId, jobId);
                            } else {
                                if (!hasAdvancedSchedulerEnabled ||
                                    hasAdvancedSchedulerEnabled && (mode === 'modifyMessage' || mode === 'modifySchedule') ||
                                    hasAdvancedSchedulerEnabled && (interviewType === 'Deadline' || interviewType === 'NoSchedule')) {
                                    jvHireUrlService.navigateToCandidateScheduler(applicationId, stateId);
                                }
                                else {
                                    // Change the URL to the new Advanced Scheduler page
                                    $window.location.href = jvHireUrlService.navigateToCandidateSmartScheduler({
                                        appid: applicationId,
                                        wfsid: stateId,
                                        jobid: jobId
                                    }, '/interviewInformation');
                                }
                            }
                        }
                    });
                }
            });

            $scope.redirectOnCancel = function (doNotReRender) {
                $scope.selectedTimezoneObj = $scope.$parent.selectedTimezoneObj = null;
                //redirect to list page on cancel if user comes to adv sch page from list page
                var redirectToListPage = JSON.parse(window.localStorage.getItem('redirectToListAfterSchedule'));
                if (redirectToListPage) {
                    var CandidateListUrl = $scope.jvUrls.source + '/person/applicants.html?updateFetch=true';
                    $window.location.href = CandidateListUrl;
                } else {
                    if (doNotReRender) {
                        $scope.$parent.reRenderEvents = false;
                    }
                    //#/workflow/{{params.applicationId}}"
                    $scope.getWorkflowSummary(1);
                    jvHireUrlService.loadCandidateDetailsTab('workflow', $routeParams.applicationId);
                }
                return;
            };

            /* ===========================================================================
               cleanAdvancedSchedulerStorage
               * Remove all localStorage related to Advanced Scheduler session
               ========================================================================== */
            var cleanAdvancedSchedulerStorage = function () {
                $window.localStorage.removeItem('advancedSchedule_timeSlots');
                $window.localStorage.removeItem('advancedSchedule_proposedInterviewInformation');
                $window.localStorage.removeItem('advancedSchedule_finalSchedules');
            };

            //Used to switch the application when user click the job Application dropdown
            $scope.switchApplication = function (applicationId) {
                if (angular.isDefined(applicationId) && applicationId !== '') {
                    GAService.track('Switched Application');
                    $scope.paginate('', applicationId);
                }
            };
            //@TODO: remove once candidate pagination is GA
            $scope.viewApplications = angular.noop;
            var viewApplications = function (readMode, currentApplication) {
                readMode = readMode ? 'readMode=0' : 'readMode=1';
                candidates.viewApplications($routeParams.applicationId, readMode, function (res) {
                    $scope.allApplications = {
                        list: [], //are only active
                        start: 1,
                        end: 10,
                        page: 0,
                        map: {},
                        allReqs: res.applications || []
                    };
                    if (res.applications) {
                        angular.forEach(res.applications, function (val) {
                            $scope.allApplications.map[val.job.EId] = val;
                            $scope.allApplications.list.push(val);
                        });
                        if ($scope.allApplications.list.length <= 10) {
                            $scope.allApplications.end = $scope.allApplications.list.length;
                        } else {
                            $scope.allApplications.end = 10;
                        }
                        $scope.applicationList = $scope.allApplications.list;
                        angular.forEach($scope.applicationList, function (application) {
                            if ((application.job.requisitionId || '').trim().length) {
                                application.job.reqIdTitle = application.job.title + ' ' + '(' + (application.job.requisitionId || '').trim() + ')';
                            } else {
                                application.job.reqIdTitle = application.job.title;
                            }
                            application.reqIdTitle = application.job.reqIdTitle;
                        });
                        $scope.selectedApplication = angular.copy(currentApplication);
                        //adding req it with title
                        if (($scope.selectedApplication.job.requisitionId || '').trim().length) {
                            $scope.selectedApplication.job.reqIdTitle = $scope.selectedApplication.job.title + ' ' + '(' + ($scope.selectedApplication.job.requisitionId || '').trim() + ')';
                        } else {
                            $scope.selectedApplication.job.reqIdTitle = $scope.selectedApplication.job.title;
                        }
                        $scope.selectedApplication.reqIdTitle = $scope.selectedApplication.job.reqIdTitle;
                    }
                });
            };

            var getWorkFlowStepsMap = function () {
                //HIRE-7676 - There is a timing issue where applicationDetails calls comes after workflow call.
                //As a result there is a console error. The callers were already doing a check on receiving null
                //from this call. This fixes the issue, but workflowSteps shoudl be always present when the page is loaded.
                //Will be moving that to the initial page load itself and not dependent on any API call.
                if (angular.isUndefined($scope.workflowSteps)) {
                    return null;
                }
                $scope.workflowStepsMap = {};
                //CREATE A MAP STRUCTURE FOR PERFORMANCE
                for (var i = 0; i < $scope.workflowSteps.length; i++) {
                    var id = $scope.workflowSteps[i].workflowElementInfo.EId;
                    $scope.workflowStepsMap[id] = $scope.workflowSteps[i].workflowElementInfo.metaModel.candidateState;
                }
                return $scope.workflowStepsMap;
            };

            /**
             * @method performWorkFlowAction
             * @description Based on the user confirmation triggers the relevant action
             * @params {string} nextStateEId - next state ID
             * @params {string} stateEId - state EID
             * @params {number} kind - action number
             */
            var performWorkFlowAction = function (nextStateEId, stateEId, kind) {
                $scope.nextWorkflowStep = {
                    nextStateEId: nextStateEId,
                    stateEId: stateEId,
                    kind: kind
                };

                var workflowStepsMap = getWorkFlowStepsMap();
                var wfStep = workflowStepsMap[$scope.nextWorkflowStep.nextStateEId];
                var hasAdvancedSchedulerEnabled = false;

                //Totango. Called when there is a change to workflow step.
                jvTotango.track('Change Application Status', 'Recruiter');

                if (wfStep) {
                    switch (wfStep.itemId) {
                        case 1:
                            if ($scope.nextWorkflowStep.kind === 0) {
                                $scope.generateOffer(wfStep.EId);
                            }
                            break;
                        case 4:
                            if ($scope.nextWorkflowStep.kind === 12) {
                                $scope.sendOfferLetter(wfStep.EId);
                            } else {
                                $scope.updateWorkflowActions(wfStep);
                            }
                            break;
                        case 5:
                            window.open('../requisitions/addHire_close.html#/offerAccept/' + $routeParams.applicationId + '/' + wfStep.EId, '_self');
                            break;
                        case 6:
                            if ($scope.properties.offerDispositionFormEnabled) {
                                $scope.showOfferDispositionForm(wfStep.EId);
                            } else {
                                $scope.updateWorkflowActions(wfStep);
                            }
                            break;
                        case 7:
                            if ($scope.nextWorkflowStep.kind === 0) {
                                $scope.rejectCandTrigger();
                            }
                            break;
                        case 8:
                            if ($scope.nextWorkflowStep.kind === 0) {
                                $scope.getSubmitToHM(wfStep.EId);
                            }
                            break;
                        case 9:
                            $scope.candApproveRej($scope.nextWorkflowStep.stateEId, true);
                            break;
                        case 10:
                            $scope.candApproveRej($scope.nextWorkflowStep.stateEId, false);
                            break;
                        case 11:
                            if ($scope.nextWorkflowStep.kind === 0) {
                                $scope.generateViewOfferLetter(wfStep.EId, false);
                            } else if ($scope.nextWorkflowStep.kind === 10) {
                                $scope.generateViewOfferLetter(wfStep.EId, true);
                            }
                            break;
                        case 0:
                            if ($scope.nextWorkflowStep.kind === 0 && wfStep.kind === 'VIDEO_SCREEN') {
                                $scope.sendVideoInterview(wfStep.EId, wfStep.kind, function () {
                                    $scope.updateWorkflowActions(wfStep);
                                });
                            } else if ($scope.nextWorkflowStep.kind === 0 && (wfStep.kind === 'PRE_OFFER_DATA_COLLECTION' || wfStep.kind === 'POST_OFFER_DATA_COLLECTION')) {
                                $scope.getOfferDataCollection(wfStep.EId, wfStep.kind);
                            } else if ($scope.nextWorkflowStep.kind === 0 && wfStep.kind === 'ONBOARDING_JOBVITE') {
                                $scope.candSendToOnboarding(wfStep.EId, 'send');
                            }
                            else {
                                $scope.updateWorkflowActions(wfStep);
                            }
                            break;
                        default:
                            $scope.updateWorkflowActions(wfStep);
                    }
                } else {
                    if ($scope.nextWorkflowStep.kind === 5) {
                        var wfStepEId = $scope.nextWorkflowStep.stateEId;
                        var jobId;

                        if ($scope.appDetails.application.job) {
                            if ($scope.appDetails.application.job.EId) {
                                jobId = $scope.appDetails.application.job.EId;
                            } else {
                                jobId = 'onV9Vfw6'; //0 - General Application
                            }
                        }

                        candidates.getWorkflowDetails($routeParams.applicationId, wfStepEId, function (res) {
                            var interviewType = res.workflowActivities.workflowElementInfo.metaModel.interviewStatus;
                            hasAdvancedSchedulerEnabled = res.workflowActivities.model.advancedSchedulerEnabled;
                            $scope.$root.mode = $scope.mode = 'schedule';
                            $scope.$root.interviewStatus = interviewType;
                            //Redirect to basic scheduler
                            if (interviewType === 'NoSchedule' || interviewType === 'Deadline') {
                                navigate('workflow-messager/' + $routeParams.applicationId + '/' + wfStepEId);
                            }
                            else if (!hasAdvancedSchedulerEnabled) {
                                if (interviewType === 'Schedule') {
                                    navigate('workflow-scheduler/' + $routeParams.applicationId + '/' + wfStepEId);
                                }
                            } else {
                                cleanAdvancedSchedulerStorage();
                                $window.location.href = jvHireUrlService.navigateToCandidateSmartScheduler({
                                    appid: $routeParams.applicationId,
                                    wfsid: wfStepEId,
                                    jobid: jobId
                                }, '/interviewInformation');
                            }
                        });
                        $scope.currentTab = workflowTab;
                    } else if ($scope.nextWorkflowStep.kind === 13) {
                        $window.location.href = $window.jvUrls.jhire +
                            '/modules/candidates/details/workflow/selfScheduler.html#/' +
                            'scheduler/' + $routeParams.applicationId +
                            '/' + $scope.nextWorkflowStep.stateEId;
                    } else if ($scope.nextWorkflowStep.kind === 14) {
                        window.open($window.goodTimeUrl.format($routeParams.applicationId, $scope.appDetails.application.candidate.EId, $scope.nextWorkflowStep.stateEId));
                    }
                }
            };

            /**
             * @method trigger
             * @description triggers the worflow actions based on the user confirmation
             * @params {string} nextStateEId - next state ID
             * @params {string} stateEId - state EID
             * @params {number} kind - action number
             */
            $scope.trigger = function (nextStateEId, stateEId, kind) {
                $scope.$broadcast('isFormEditInProgessEvt');
                if ($rootScope.isFormEditInProgress) {
                    if (window.confirm('\n' + i18n.NAV_AWAY_WARNING_MESSAGE + '\n' + i18n.NAV_AWAY_CONFIRM)) {
                        performWorkFlowAction(nextStateEId, stateEId, kind);
                    }
                } else {
                    performWorkFlowAction(nextStateEId, stateEId, kind);
                }
            };

            $scope.closeMiniHeader = function (home) {
                $rootScope.miniHeader.show = false;
                if (home) {
                    navigate('summary/' + $routeParams.applicationId);
                    $scope.currentTab = summaryTab;
                } else {
                    navigate($rootScope.miniHeader.back);
                    var tabObj = getTabObject('#/' + $rootScope.miniHeader.back);
                    $scope.currentTab = tabObj.tabType;
                }
            };

            $scope.sendOfferLetter = function (stateId) {
                if (window.location.hash.indexOf('workflow-generateOfferLetter') > -1) {
                    $rootScope.fastRead.uploadOffer = true;
                }
                candidates.savePreOfferData();
                $scope.offerLetter.send = $scope.canSendOffer;
                if ($scope.canSendOffer) {
                    navigate('workflow-sendOfferLetter/' + $routeParams.applicationId + '/' + stateId, 'workflow-sendOfferLetter');
                } else {
                    $scope.$apply();
                }
            };

            $scope.message.submit = function () {
                if ($scope.message.modal === 'submitToHM') {
                    $scope.submitToHM($scope.subitHMId);
                }
            };

            $scope.offerMessage.submit = function () {
                $scope.postCompliance();
            };

            $scope.postCompliance = function () {
                if ($scope.offerMessage && (!$scope.offerMessage.content || $scope.offerMessage.content.trim() === '')) {
                    $scope.offerMessage.checkText.content = true;
                    return;
                }
                if ($scope.offerMessage && (!$scope.offerMessage.subject || $scope.offerMessage.subject.trim() === '')) {
                    $scope.offerMessage.checkText.subject = true;
                    return;
                }

                $scope.complianceModal = false;

                var data = {};

                if ($scope.offerMessage.to) {
                    data.toList = [$scope.offerMessage.to[0].EId];
                    data.content = $scope.offerMessage.content || '';
                    data.subject = $scope.offerMessage.subject || '';
                    data.formIdList = $scope.offerMessage.forms || [];
                    data.locale = $scope.offerMessage.locale || '';
                }

                $scope.flags.loading = true;
                if ($scope.offerMessage.modal === 'PRE_OFFER_DATA_COLLECTION') {
                    candidates.savePreOfferData($routeParams.applicationId, $scope.offerMessage.stateId, data, function (res) {
                        if (res.msgInfo === $scope.status.OK || res.msgInfo === 0) {
                            $scope.showMsg('OFCCP_OFFER_SENT');
                            if ($scope.activeTab('messages')) {
                                var count = !$.isEmptyObject($scope.messages) ? 1 : $scope.page.count;
                                $scope.getMessages(0, count, null, 0);
                            }
                            $scope.getMessagesCount(true);
                            $scope.updateWorkflowActions();
                        }
                        $scope.flags.loading = false;
                    }, function () {
                        $scope.flags.loading = false;
                    });
                }
                else if ($scope.offerMessage.modal === 'POST_OFFER_DATA_COLLECTION') {
                    candidates.savePostOfferData($routeParams.applicationId, $scope.offerMessage.stateId, data, function (res) {
                        if (res.msgInfo === $scope.status.OK || res.msgInfo === 0) {
                            $scope.showMsg('OFCCP_OFFER_SENT');
                            if ($scope.activeTab('messages')) {
                                var count = !$.isEmptyObject($scope.messages) ? 1 : $scope.page.count;
                                $scope.getMessages(0, count, null, 0);
                            }
                            $scope.getMessagesCount(true);
                            $scope.updateWorkflowActions();
                        }
                        $scope.flags.loading = false;
                    }, function () {
                        $scope.flags.loading = false;
                    });
                }
            };
            $scope.rejectCandTrigger = function () {
                if ($window.disableFlags && $window.disableFlags.rejectCandidate) {
                    $scope.getRejectCandidateDetails();
                } else {
                    var rejectObject = {};
                    rejectObject.appId = $routeParams.applicationId;
                    rejectObject.candidateEId = $scope.appDetails.application.candidate.EId;
                    rejectObject.email = $scope.appDetails.application.candidate.email;
                    rejectObject.name = $scope.appDetails.application.candidate.firstName + ' ' + $scope.appDetails.application.candidate.lastName;
                    rejectObject.allApplicationsList = $scope.allApplications.list;
                    rejectObject.moveCandidateEnabled = true;
                    $rootScope.$broadcast('showRejectCandidateModal', false, rejectObject);
                }
            };

            jvHireBroadcastSVC.subscribe('rejectCandidateSuccess', function (event, onlyReset, multiple, rejectObject) {
                if (onlyReset) {
                    return;
                }
                if (rejectObject) {
                    $scope.showMsg(rejectObject.moveCandidateEnabled ? 'CANDIDATE_REJECTED' : 'I18N_REJECT_MOVE_CANDIDATE_MODAL');
                } else {
                    $scope.showMsg('CANDIDATE_REJECTED');
                }
                $scope.getApplicationDetails(true);
            });

            jvHireBroadcastSVC.subscribe('rejectCandidateFailure', function () {
                $scope.showMsg('ERROR');
            });

            $scope.formFunctions = function (candidateForm) {
                $scope.preInterviewForm = jvCandidateDetailsProcessFormFAC(candidateForm);
                $scope.preInterviewForm.showClose = false;
                if (candidateForm.workFlowName) {
                    $scope.preInterviewForm.workFlowName = candidateForm.workFlowName;
                    $scope.preInterviewForm.showClose = true;
                }
            };

            $scope.getRejectCandidateDetails = function () {
                $scope.flags.loading = true;
                candidates.getRejectCandidateDetails($routeParams.applicationId, function (res) {
                    function buildRejectObject(agency, templates, agencyEId, rejectEmailEnabled, candidateEmail) {
                        var rejectObject = findDefaultTemplate(templates);

                        if (agency) {
                            angular.extend(rejectObject, {
                                to: agencyEId,
                                sendEmail: rejectEmailEnabled
                            });
                        } else {
                            angular.extend(rejectObject, {
                                sendEmail: rejectEmailEnabled && !!candidateEmail
                            });
                        }

                        return rejectObject;
                    }

                    var FOR_CANDIDATE = false;
                    var FOR_AGENCY = true;

                    $scope.flags.loading = false;
                    $scope.rejectInfo = res.interviewType.workflowElementInfo.metaModel;
                    $scope.rejectInfo.rejectTemplates = $scope.rejectInfo.candidateRejectTemplates = res.interviewType.model.rejectTemplates || [];
                    $scope.rejectInfo.rejectionEmailEnabled = res.interviewType.model.rejectionEmailEnabled;
                    $scope.rejectInfo.show = true;

                    $scope.reject = buildRejectObject(FOR_CANDIDATE, $scope.rejectInfo.rejectTemplates, $scope.$eval('rejectInfo.agency.EId'), $scope.rejectInfo.rejectionEmailEnabled, $scope.appDetails.application.candidate.email);

                    if (res.interviewType.model.agency) {
                        $scope.rejectInfo.agency = res.interviewType.model.agency;
                        $scope.rejectInfo.rejectTemplates = $scope.rejectInfo.agencyRejectTemplates = res.interviewType.model.agencyRejectTemplates || [];

                        $scope.reject = buildRejectObject(FOR_AGENCY, $scope.rejectInfo.rejectTemplates, $scope.rejectInfo.agency.EId, $scope.rejectInfo.rejectionEmailEnabled, $scope.appDetails.application.candidate.email);
                    }
                });
            };

            $scope.showActiveApplicationModal = function () {
                $scope.rejectInfo.show = false;
                $scope.showActiveApplications = true;
            };

            $scope.doAction = function (eid, actionType) {
                if (actionType === 'Candidate.QuickView') {
                    $scope.quickReq($scope.appDetails.application.EId);
                } else if (actionType === 'Requistion.QuickView') {
                    $scope.quickCand(eid);
                }
            };

            //watching for events that trigger the requisition quikview
            jvHireBroadcastSVC.subscribe('triggerRequisitionQuickView', function (event, requisitionId) {
                if (requisitionId) {
                    $scope.quickCand(requisitionId);
                }
            });

            $scope.quickCand = function (requisitionId) {
                $scope.flags.loading = true;
                candidates.quickView(requisitionId, function (data) {
                    $scope.flags.loading = false;
                    angular.extend($scope.quickView, data.jobDetails);
                    if (!data.jobDetails.jobLocations || data.jobDetails.jobLocations.length === 0) {
                        delete $scope.quickView.jobLocations;
                    }
                    $scope.quickView.hasJobAccess = data.hasJobAccess;
                    $scope.postOptions = data.postOptions;
                    $scope.quickView.show = 'requisitions';
                });
            };

            $scope.quickReq = function (requisitionId) {
                $scope.quickViewdata = {
                    id: requisitionId,
                    candId: $scope.appDetails.application.candidate.EId
                };
                if ($scope.isNewJQuery) {
                    $window.jv.modalNew.init($scope.quickViewdata, 'jv-modalDialog', true);
                } else {
                    $window.jv.modal.init($scope.quickViewdata, 'jv-modalDialog', true);
                }
            };

            //Added these here instead of bringing in grid.controller.js file as it depends on ngRoute and angular1.2.9 -NV
            $scope.$on('REJECT_CANDIDATES_MODAL_CLICKED', function (event, bulk, value) {
                $rootScope.$broadcast('showRejectCandidateModal', bulk, value);
            });

            $scope.$on('SUBMIT_HM_MODAL_CLICKED', function (event, value) {
                $rootScope.$broadcast('showsubmitToHMModal', value);
            });

            $scope.templates = TemplateLoader.register({
                changeStatus: '/jhire/modules/candidates/modals/changeStatus.html'
            });

            $scope.$on('CHANGE_STATUS_MODAL_CLICKED', function (event, value) {
                $rootScope.$broadcast('showChangeStatusModal', value);
            });

            var sendVideoInterviewHelper = function (workflowObject, callback) {
                var fullName = $scope.appDetails.application.candidate.firstName + ' ' + $scope.appDetails.application.candidate.lastName;
                var promise = VideoInterviewInviteModalService.inviteCandidates(fullName, $scope.appDetails.application.EId, workflowObject, $scope.appDetails.application.job.EId);
                promise.then(function (ifVideoInterviewInviteSent) {
                    if (ifVideoInterviewInviteSent === true) {
                        $rootScope.$broadcast('LOAD_VIDEO_APPLICATIONS_LIST');
                        if (callback) {
                            callback();
                        }
                    } else if (ifVideoInterviewInviteSent === false) {
                        $rootScope.error = 'Unable to perform operation.';
                    }
                });
            };

            $scope.sendVideoInterview = function (stateId, workflowStateKind, callback) {
                var workflowObject = {};
                workflowObject.stateId = stateId;
                workflowObject.workflowStateKind = workflowStateKind;
                sendVideoInterviewHelper(workflowObject, callback);
            };

            $scope.sendVideoInterviewAdhoc = function () {
                sendVideoInterviewHelper();
            };

            $scope.normalizeWorkflow = function (workflow) {
                var isEval = false;
                if (workflow.model && (workflow.model.hmMessages || workflow.model.hmMessagesSubmitted)) {
                    var model = workflow.model;
                    $scope.setHmMessages(model);
                }

                if (workflow.model && workflow.model.integrationMessage && workflow.model.integrationMessage.jsonMessage) {
                    workflow.model.integrationMessage.jsonMessage = $scope.getStringInJson(workflow.model.integrationMessage.jsonMessage);
                }

                if (workflow.model && workflow.model.backgroundCheckStatus && workflow.model.partner === 'hireright') {
                    workflow.model.backgroundCheckStatus = $scope.getStringInJson(workflow.model.backgroundCheckStatus);
                }

                if (workflow.model && workflow.model.interviews && workflow.model.interviews.length > 0) {
                    for (var m = 0; m < workflow.model.interviews.length; m++) {
                        if (workflow.model.interviews[m].scheduleUtc) {
                            var d = new Date(angular.copy(workflow.model.interviews[m].scheduleUtc));
                            workflow.model.interviews[m].scheduleUtc = d.getTime();
                        }

                        if (workflow.model.interviews[m].scheduleEndDate < new Date().getTime() && !isEval) {
                            isEval = true;
                        }
                    }

                    if (workflow.workflowElementInfo.metaModel.interviewStatus === 'NoSchedule') {
                        isEval = true;
                    }

                    workflow.model.isEval = isEval;

                    var cloneInterviews = angular.copy(workflow.model.interviews);
                    cloneInterviews = $filter('orderBy')(cloneInterviews, 'scheduleUtc');

                    //Groupin Interview based on groupId
                    var interviewGrps = {};
                    var grpCount = 0;
                    var commonAction = ['submitEvaluation', 'viewEvaluation', 'sendEvaluationReminder', 'viewForm', 'scheduleInterview', 'scheduleAnotherInterview', 'scheduleInterviewGoodTime', 'scheduleAnotherInterviewGoodTime', 'requestCandidateAvailability'];
                    angular.forEach(cloneInterviews, function (interview) {
                        if (interview.groupId) {
                            if (!interviewGrps[interview.groupId]) {
                                interviewGrps[interview.groupId] = [];
                                grpCount++;
                            }
                            interviewGrps[interview.groupId].push(interview);
                        }
                    });
                    var showActions = {};
                    var dateRangeArr = {};
                    var dateAndActions;
                    var groupedInterviewArray = [];
                    var temp;
                    //Looping through the constructed interview groups to get status and data range of the interview.
                    if (!$.isEmptyObject(interviewGrps)) {
                        angular.forEach(interviewGrps, function (interviews, grpId) {
                            temp = {};
                            dateAndActions = getInterviewDateAndActions(interviews);
                            angular.extend(showActions, dateAndActions.showActions);
                            dateRangeArr[grpId] = dateAndActions.dateRangeArr[grpId];

                            temp[grpId] = interviews;
                            // To show the group in desecending order, this array is created.
                            groupedInterviewArray.unshift(temp);
                        });
                    }
                    workflow.model.dateRange = dateRangeArr;
                    workflow.model.groupedInterviewArray = groupedInterviewArray;
                    workflow.model.showActions = showActions;

                    //Grouping interviewMessages based on gropuId.
                    if (!$.isEmptyObject(workflow.model.interviewMessages)) {
                        workflow.model.interviewMessages = groupingInterviewMsgs(workflow.model.interviewMessages);
                    }
                    if (grpCount === 1) {
                        workflow.model.intGrpPresent = false;
                        // Read the groupId when there is only one group and passing to the scope, this group Id is used while modify or cancel interview.
                        for (var groupId in interviewGrps) {
                            workflow.model.groupId = groupId;
                            var interviews = interviewGrps[groupId];

                            if (workflow.model.isGoodTimeEnabled && workflow.elementActionsArr) {
                                var showGoodTimeTabs = true;
                                for (var i = 0; i < interviews.length; i++) {
                                    if (angular.isDefined(interviews[i].externalId)) {
                                        workflow.model.externalInterviewId = interviews[i].externalId;
                                    }
                                }

                                if (!workflow.model.externalInterviewId) {
                                    showGoodTimeTabs = false;
                                }

                                for (var index in workflow.elementActionsArr) {
                                    var elem = workflow.elementActionsArr[index];
                                    if (!showGoodTimeTabs && (elem.title === 'modifyScheduleGoodTime' || elem.title === 'cancelInterviewGoodTime')) {
                                        workflow.elementActionsArr.splice(index, 1);
                                    }
                                    if (showGoodTimeTabs && (elem.title === 'modifySchedule' || elem.title === 'cancelInterview')) {
                                        workflow.elementActionsArr.splice(index, 1);
                                    }
                                }
                            }
                        }
                    } else {
                        workflow.model.intGrpPresent = true;
                        //grouping the actions
                        var actions = {
                            common: [],
                            specific: {}
                        };
                        angular.forEach(workflow.elementActionsArr, function (action) {
                            if ($.inArray(action.title, commonAction) !== -1) {
                                actions.common.push(action);
                            }
                        });

                        angular.forEach(interviewGrps, function (interviews, groupId) {
                            actions.specific[groupId] = [];
                            angular.forEach(workflow.elementActionsArr, function (elemAction) {
                                var action = angular.copy(elemAction);
                                if ($.inArray(action.title, commonAction) === -1) {
                                    if (action.title === 'modifyScheduleGoodTime' || action.title === 'cancelInterviewGoodTime') {
                                        if (!workflow.model.isGoodTimeEnabled) {
                                            return;
                                        }

                                        for (var i = 0; i < interviews.length; i++) {
                                            if (interviews[i].externalId) {
                                                action.externalInterviewId = interviews[i].externalId;
                                            }
                                        }

                                        if (!action.externalInterviewId) {
                                            return;
                                        }
                                    }

                                    if (action.title === 'modifySchedule' || action.title === 'cancelInterview') {
                                        if (workflow.model.isGoodTimeEnabled) {
                                            for (var index in interviews) {
                                                if (angular.isDefined(interviews[index].externalId)) {
                                                    return;
                                                }
                                            }
                                        }
                                    }
                                    actions.specific[groupId].push(action);
                                }
                            });
                        });
                        workflow.elementActionsArr = actions;
                    }
                } else {
                    // Interview message grouping when there are no interviews
                    if (workflow.model && !$.isEmptyObject(workflow.model.interviewMessages)) {
                        workflow.model.interviewMessages = groupingInterviewMsgs(workflow.model.interviewMessages);
                    }
                }

                if (workflow.model && workflow.model.offerApproval && workflow.model.offerApprovalSummary) {
                    workflow.model.offerApprovalForms = [];

                    var k = 0;
                    for (var j = 0; j < workflow.model.offerApprovalSummary.length; j++) {
                        var obj = {
                            date: new Date(workflow.model.offerApprovalSummary[j].date),
                            users: []
                        };
                        for (; k < workflow.model.offerApproval.length; k++) {
                            if (k > 0) {
                                if (workflow.model.offerApproval[k].position <= workflow.model.offerApproval[k - 1].position && !workflow.model.offerApproval[k].checked) {
                                    workflow.model.offerApproval[k].checked = true;
                                    break;
                                } else {
                                    obj.users.push(workflow.model.offerApproval[k]);
                                }
                            } else {
                                obj.users.push(workflow.model.offerApproval[k]);
                            }
                        }
                        if (j === workflow.model.offerApprovalSummary.length - 1) {
                            obj.expanded = true;
                        }
                        workflow.model.offerApprovalForms.push(obj);
                    }
                }
            };

            $scope.getWorkflowSummary = function (dbMode) {
                $scope.addLoading('candidates.getWorkflowSummary');
                var data = {};

                if (!dbMode || $scope.fromGoto || dbMode === true) {
                    data.readMode = 0;
                    $scope.fromGoto = false;
                    /*Preparing a timer for fast read request to switch on/off during replication time*/
                    $rootScope.fastReadOn = true;
                    if (fastReadTimerFn) {
                        $timeout.cancel(fastReadTimerFn);
                    }
                    fastReadTimerFn = $timeout(function () {
                        $rootScope.fastReadOn = false;
                    }, REPLICATION_DELAY_MS);
                } else {
                    data.readMode = dbMode;
                }

                candidates.getWorkflowSummary($routeParams.applicationId, $.param(data), function (res) {
                    var ret = {};
                    ret.interviewType = [];

                    if (res.workflowSummary) {
                        angular.forEach(res.workflowSummary, function (element, m) {
                            if (res.workflowSummary[m].elementActions) {
                                res.workflowSummary[m].elementActionsArr = [];
                                angular.forEach(res.workflowSummary[m].elementActions, function (action, key) {
                                    action.title = key;
                                    res.workflowSummary[m].elementActionsArr.push(action);
                                });
                            }

                            //VA: Not sure why the workflow logic is put inside the cand controllers. every module is different and every tab should have its own files not share logic. For the time being just put the logic.
                            if (res.workflowSummary[m].workflowElementInfo &&
                                res.workflowSummary[m].workflowElementInfo.metaModel &&
                                res.workflowSummary[m].workflowElementInfo.metaModel.candidateState &&
                                res.workflowSummary[m].workflowElementInfo.metaModel.candidateState.kind &&
                                res.workflowSummary[m].workflowElementInfo.metaModel.candidateState.kind === 'VIDEO_SCREEN'
                            ) {
                                var _usersHash = {};
                                angular.forEach(res.workflowSummary[m].model.users, function (value) {
                                    _usersHash[value.EId] = value;
                                });
                                res.workflowSummary[m].model.usersHash = _usersHash;
                            }

                            //VA: Not sure why the workflow logic is put inside the cand controllers. every module is different and every tab should have its own files not share logic. For the time being just put the logic.
                            if (res.workflowSummary[m].workflowElementInfo.elementName === 'Offer Generation') {
                                $scope.canSendOffer = res.workflowSummary[m].model.canSendOffer;
                            }
                            $scope.normalizeWorkflow(res.workflowSummary[m]);
                        });

                        $scope.workflowStepsMap = getWorkFlowStepsMap();
                        res.workflowSummary = res.workflowSummary.reverse();
                        $scope.workSteps = res.workflowSummary;

                        for (var i = 0; i < $scope.workSteps.length; i++) {
                            if ($scope.params && $scope.params.stateEId) {
                                if ($scope.workSteps[i].workflowElementInfo.EId === $scope.params.stateEId) {
                                    $scope.$broadcast('setWorkflowAsPreSelected', {
                                        stepIndex: i,
                                        stateEId: $scope.params.stateEId
                                    });
                                    break;
                                }
                            } else if ($scope.appDetails.application && $scope.appDetails.application.workflowStateEId === $scope.workSteps[i].workflowElementInfo.EId) {
                                $scope.workflowStateId = $scope.workSteps[i].workflowElementInfo.EId;
                                $scope.$broadcast('setWorkflowAsPreSelected', {
                                    stepIndex: i,
                                    stateEId: $scope.workflowStateId
                                });
                                $scope.workSteps[i].expanded = true;
                                break;
                            }
                        }
                    }
                    $scope.removeLoading('candidates.getWorkflowSummary');
                }, function () {
                    $scope.removeLoading('candidates.getWorkflowSummary');
                });
            };

            $scope.setHmMessages = function (model) {
                model.hmMsgs = [];
                if (model.hmMessagesSubmitted) {
                    for (var m = 0; m < model.hmMessagesSubmitted.length; m++) {
                        model.hmMessagesSubmitted[m].kind = 'SUBMITTED_TO_HIRING_MANAGER';
                        model.hmMessagesSubmitted[m].date = model.hmMessagesSubmitted[m].message.sentDate;
                        model.hmMsgs.push(model.hmMessagesSubmitted[m]);
                    }
                }
                if (model.hmMessages) {
                    var workflowStepsMap = getWorkFlowStepsMap();
                    if (workflowStepsMap) {
                        for (var i = 0; i < model.hmMessages.length; i++) {
                            // Added null check for HIRE:8714 - Workflow tab of candidate shows no data
                            if (workflowStepsMap[model.hmMessages[i].stateEId]) {
                                if (workflowStepsMap[model.hmMessages[i].stateEId].predefinedKind === 'SUBMITTED_TO_HIRING_MANAGER') {
                                    model.hmMessages[i].kind = 'SUBMITTED_BY_USER';
                                } else {
                                    model.hmMessages[i].kind = workflowStepsMap[model.hmMessages[i].stateEId].predefinedKind;
                                }
                                model.hmMsgs.push(model.hmMessages[i]);
                            }
                        }
                    }
                }
            };
            /**
             * NOTES & MESSAGES - methods/watches
             */
            $scope.initializeTasks = function () {
                $scope.taskQForm = $scope.taskQForm || {};
                $scope.taskQForm.action = 'doAddTask';
                $scope.taskQForm.type = 1;
                $scope.taskQForm.status = 'Open';
                $scope.taskQForm.dueDate = '';
                $scope.taskQForm.notes = '';
                $scope.taskQForm.dateFlag = false;
                $scope.taskQForm.noteFlag = false;
                $scope.flags.tasks.inDraft = false;

                $scope.$watch('taskQForm.notes', function (newValue) {
                    if ((newValue || '').trim().length) {
                        $scope.flags.tasks.inDraft = true;
                        $scope.taskQForm.noteFlag = false;
                    }
                });
                $scope.$watch('taskQForm.dueDate', function (newValue) {
                    if ((newValue || '').trim().length) {
                        $scope.flags.tasks.inDraft = true;
                        $scope.taskQForm.dateFlag = false;
                    }
                });
            };

            $scope.saveTask = function (form) {
                //set entityType before entityEId
                $scope.taskQForm.entityType = 'Application';
                var postData = angular.copy(form);
                postData.entityEId = $scope.appDetails.application.EId;
                postData.entityName = encodeURIComponent($scope.appDetails.application.candidate.firstName + ' ' + $scope.appDetails.application.candidate.lastName + ': ' + $scope.appDetails.application.job.title);
                //using postData obj so that the user doesnt see url encoded text on the UI
                postData.notes = encodeURIComponent(postData.notes);
                if (!!postData.ownerEId && (postData.ownerEId.EId || '').trim().length) {
                    postData.ownerEId = postData.ownerEId.EId;
                }
                candidates.addTask(postData, function (result) {
                    $scope.cancelFlyout('tasks');
                    $scope.flags.tasks.inDraft = false;
                    if (result.status === 'Open') {
                        $scope.showMsg('TASK_ADDED');
                    }
                    if ($scope.activeTab('tasks')) {
                        document.getElementById('jv-tasksIframe').contentWindow.location.reload();
                    }
                });
            };

            $scope.savePost = function (form) {
                $scope.flags.loading = true;
                jvCandidatesService.sharePost($scope.appDetails.application.EId, form, function (response) {
                    $scope.flags.loading = false;
                    if (response && response.data && response.data.msgInfo === 200) {
                        $scope.showMsg('POST_SHARED');
                        GAService.track('Post Created');
                        $scope.cancelFlyout('post');
                    }

                    if ($scope.activeTab('feed')) {
                        $rootScope.$emit('refreshFeed');
                    }
                });
            };

            $scope.saveNote = function (form, index, isMessageReply) {
                var data = {},
                    to = [];
                form.attachmentEids = [];
                if (form.to && form.to.length) {
                    angular.forEach(form.to, function (recipient) {
                        to.push(recipient.EId);
                    });
                } else {
                    if (angular.isObject(form.to)) {
                        var toList = angular.copy(form.to);
                        to.push(toList.EId);
                    }
                }

                var cloneForm = angular.copy(form);
                cloneForm.to = to;
                form.attachmentEids = [];


                //Commenting out my tinymce changes NV
                //Since we now have a tinymce editor
                //form.content = tinyMCE.activeEditor.getContent();

                if (!form.content || !form.subject || form.subject.length > 150) {
                    $scope.flags.noteMandetoryFlag = true;
                    if (index >= 0) {
                        if (isMessageReply) {
                            $scope.messages[index].form = true;
                        } else {
                            $scope.notes[index].form = true;
                        }
                    }
                    return;
                }
                if (form.someoneElse && !index) {
                    if (!form.to || form.to.length === 0) {
                        $scope.flags.noteMandetoryFlag = true;
                        return;
                    }
                }

                data.content = form.content;
                data.subject = form.subject;

                if (cloneForm.to.length > 0) {
                    data.toList = cloneForm.to;
                }

                if (!$.isEmptyObject($scope.note.attachments)) {
                    angular.forEach($scope.note.attachments, function (key) {
                        if (key.resourceInfo) {
                            form.attachmentEids.push(key.resourceInfo.eid);
                        }
                    });
                    data.attachmentList = form.attachmentEids;
                } else if (!$.isEmptyObject(form.attachments)) {
                    angular.forEach(form.attachments, function (key) {
                        if (key.resourceInfo) {
                            form.attachmentEids.push(key.resourceInfo.eid);
                        }
                    });
                    data.attachmentList = form.attachmentEids;
                }
                if ($scope.flyoutEditMode) {
                    form.EId = $scope.flyoutObjectEId;
                }
                /*BE expects locale to be sent to determine language for Email header/footer*/
                if (form && form.template && form.template.locale) {
                    data.locale = form.template.locale;
                }
                if (form.EId) {
                    /*formEId and ReqEId is passed as parameter than part of data{}*/
                    $scope.flags.loading = true;
                    candidates.updateNote($routeParams.applicationId, form.EId, data, function (res) {
                        $scope.flags.quickForms = false;
                        $scope.collapseFlyout();
                        if (res.msgInfo === $scope.status.OK) {
                            //refresh activity feed
                            $rootScope.$emit('refreshFeed');
                            $scope.flags.notes.inDraft = false;
                            //reset edit mode for edit note via feed
                            resetFlyoutEditMode();

                            $scope.candFileCheck = {};
                            $scope.flags.loading = false;
                            $scope.showMsg('NOTE_UPDATED');
                            form.form = false;
                            form.template = '';
                            $scope.notes[index] = form;
                            if ($scope.activeTab('notes')) {
                                $scope.getNotes(0, !$.isEmptyObject($scope.notes) ? $scope.notes.length : $scope.page.count, null, 0);
                            }
                            $scope.getNotesCount(true);
                            $scope.noteQForm = {};
                            //$scope.noteQForm.htmlMessage = '';
                            $scope.flags.quickForms = false;
                            $scope.flags.noteMandetoryFlag = false;
                            $scope.$broadcast('setNoteFormPristine');
                        } else {
                            $scope.flags.operationError = true;
                            if (index >= 0 && $scope.notes && $scope.notes.length && $scope.notes[index]) {
                                $scope.notes[index].form = false;
                            }
                            setTimeout(function () {
                                $scope.flags.operationError = false;
                            }, 5000);
                        }
                    });
                } else {
                    $scope.flags.loading = true;
                    candidates.addNote($routeParams.applicationId, data, function (res) {
                        $scope.collapseFlyout();
                        if (res.msgInfo === $scope.status.OK) {
                            $scope.flags.loading = false;
                            //refresh activity feed
                            $rootScope.$emit('refreshFeed');
                            //Setting the notes flyout draft state to false after adding a note.Bug 15977 NV
                            $scope.flags.notes.inDraft = false;
                            $scope.candFileCheck = {};

                            if (cloneForm.to && cloneForm.to.length > 0) {
                                $scope.showMsg('NOTE_SENT');
                            } else {
                                $scope.showMsg('NOTE_ADDED');
                            }
                            $scope.flags.add = true;
                            form.form = false;

                            if ($scope.activeTab('notes')) {
                                $scope.getNotes(0, 1, null, 0);
                            }
                            $scope.getNotesCount(true);
                            if ($scope.noteQForm.to) {
                                $scope.noteQForm.to.length = 0;
                            }

                            $scope.noteQForm = {};
                            //$scope.noteQForm.htmlMessage = '';
                            $scope.note.attachments = {};
                            $('#noteQ-Attachment-uploader ul.qq-upload-list').find('li').remove();

                            $scope.flags.quickForms = false;
                            //Closing the form after save/send
                            if (index >= 0) {
                                if (isMessageReply) {
                                    $scope.messages[index].form = false;
                                } else {
                                    $scope.notes[index].form = false;
                                }
                            }
                            $scope.flags.noteMandetoryFlag = false;
                            $scope.$broadcast('setNoteFormPristine');
                        } else {
                            $scope.flags.operationError = true;
                            if (index && $scope.notes && $scope.notes.length && $scope.notes[index]) {
                                $scope.notes[index].form = false;
                            }
                            setTimeout(function () {
                                $scope.flags.operationError = false;
                            }, 5000);
                        }
                    });
                }
            };

            /* ==========================================================================
               saveMessage
               * Saves data for a message to be sent via email from our message backend
               * @param <Object> form - messages form object
               * @param <Number> index - Index within the messages array
               * @param <Boolean> sendToAgencyOnly - If a message must be sent only to

               * an agency
               * @return N/A

               Bug #16271 - ACM - 2/10/14
               * Send to agency or candidate depending on the radio
               * Send to agency or candidate depending on the reply email on the messages
               * tab on candidate details
               ========================================================================== */

            var resetMessageQForm = function (deliveryMethod) {
                $scope.messageQForm = {
                    sendUser: 'true',
                    deliveryMethod: deliveryMethod,
                    fromPhoneData: angular.copy(defaultPhoneData)
                };
            };

            var addMessage = function (data, form, index) {
                candidates.addMessage($routeParams.applicationId, data, function (data) {
                    if (data.msgInfo === $scope.status.OK) {
                        $scope.collapseFlyout();
                        //refresh activity feed
                        $rootScope.$emit('refreshFeed');
                        $scope.flags.messages.inDraft = false;
                        $scope.flags.loading = false;
                        $scope.showMsg('MESSAGE_SENT');
                        form.form = false;
                        if ($scope.activeTab('messages')) {
                            var count = !$.isEmptyObject($scope.messages) ? 1 : $scope.page.count;
                            $scope.getMessages(0, count, null, 0);
                        }
                        $scope.getMessagesCount(true);
                        /*reset to Send As User*/
                        resetMessageQForm('EMAIL');
                        $scope.msg.attachments = {};
                        $('#Attachment-uploader ul.qq-upload-list').find('li').remove();
                        $scope.flags.quickForms = false;
                        // $scope.$broadcast('setMessageFormPristine');
                    } else {
                        $scope.flags.operationError = true;
                        /* eslint-disable no-undef */
                        if (index && $scope.messages && $scope.messages.length && $scope.messages[index]) {
                            $scope.messages[index].form = false;
                        }
                        $scope.flags.loading = false;
                        setTimeout(function () {
                            $scope.$apply('flags.operationError = false');
                        }, 10000);
                    }
                });
            };

            var addSms = function (data, form, index) {
                candidates.addSms($routeParams.applicationId, data, function (data) {
                    if (data.msgInfo === $scope.status.OK) {
                        $scope.collapseFlyout();
                        //refresh activity feed
                        $rootScope.$emit('refreshFeed');
                        $scope.flags.messages.inDraft = false;
                        $scope.flags.loading = false;
                        $scope.showMsg('MESSAGE_SENT');
                        form.form = false;
                        if ($scope.activeTab('messages')) {
                            var count = !$.isEmptyObject($scope.messages) ? 1 : $scope.page.count;
                            $scope.getMessages(0, count, null, 0);
                        }
                        $scope.getMessagesCount(true);
                        /*reset to Send As User*/
                        resetMessageQForm('SMS');
                        $scope.msg.attachments = {};
                        $('#Attachment-uploader ul.qq-upload-list').find('li').remove();
                        $scope.flags.quickForms = false;
                        // $scope.$broadcast('setMessageFormPristine');
                    } else {
                        $scope.flags.operationError = true;
                        /* eslint-disable no-undef */
                        if (index && $scope.messages && $scope.messages.length && $scope.messages[index]) {
                            $scope.messages[index].form = false;
                        }
                        $scope.flags.loading = false;
                        setTimeout(function () {
                            $scope.$apply('flags.operationError = false');
                        }, 10000);
                    }
                });
            };

            $scope.saveMessage = function (form, index, sendToAgencyOnly) {
                $scope.flags.msgMandetoryFlag = false;
                var data = '',
                    queryString = {
                        value: ''
                    },
                    bcc = [],
                    to = [],
                    cc = [],
                    cloneForm;

                form.attachmentEids = [];

                /* Validation*/
                if (((!form.subject || !form.content || form.subject.length > 150) && form.deliveryMethod !== 'SMS') || ((!form.fromPhone || !form.contentText) && form.deliveryMethod === 'SMS')) {
                    if (angular.isDefined(index) && index != null && $scope.messages && $scope.messages[index] && angular.isDefined($scope.messages[index].form)) { $scope.messages[index].form = true; }
                    $scope.flags.msgMandetoryFlag = true;
                    return;
                }

                if (form.showBCC && form.deliveryMethod !== 'SMS') {
                    angular.forEach(form.bcc, function (recipient) {
                        bcc.push(recipient.EId);
                    });
                }

                if (form.showCC && form.deliveryMethod !== 'SMS') {
                    angular.forEach(form.cc, function (recipient) {
                        cc.push(recipient.EId);
                    });
                }

                form = angular.extend({
                    attachmentEids: []
                }, form);

                /*This is to escape the special characters */
                var formContent;
                if (form.deliveryMethod === 'SMS') {
                    formContent = encodeURIComponent(form.contentText);
                } else {
                    formContent = encodeURIComponent(form.content);
                }
                var formSubject = encodeURIComponent(form.subject);
                var formRecipient = $scope.appDetails.application.EId;

                cloneForm = angular.copy(form);
                cloneForm.bcc = bcc;
                cloneForm.to = to;
                cloneForm.cc = cc;
                // TODO form.to may not be editable. Instead, the eid is taken from the current applicant ?????????
                $scope.appendToPath(queryString, 'content', formContent)
                    .appendToPath(queryString, 'subject', formSubject)
                    .appendToPath(queryString, 'to', formRecipient);

                data = data + queryString.value;
                data += '&' + $.param({
                    to: cloneForm.to,
                    bcc: cloneForm.bcc,
                    cc: cloneForm.cc,
                    sendToAgency: !!sendToAgencyOnly
                }, true);
                if (form.sendUser === 'false' && form.deliveryMethod !== 'SMS') {
                    data += '&' + $.param({
                        sendAnonymously: true
                    });
                }

                if (form.deliveryMethod !== 'SMS') {
                    if (!$.isEmptyObject($scope.msg.attachments)) {
                        angular.forEach($scope.msg.attachments, function (key) {
                            if (key.resourceInfo) {
                                form.attachmentEids.push(key.resourceInfo.eid);
                            }
                        });
                        data += '&attachments=' + form.attachmentEids.join(',');
                    } else if (!$.isEmptyObject(form.attachments)) {
                        angular.forEach(form.attachments, function (key) {
                            if (key.resourceInfo) {
                                form.attachmentEids.push(key.resourceInfo.eid);
                            }
                        });
                        data += '&attachments=' + form.attachmentEids.join(',');
                    }
                }

                if (angular.isDefined(index) && index != null) {
                    $scope.messages[index].form = false;
                }
                /*BE expects locale to be sent to determine language for Email header/footer*/
                if (form && form.template && form.template.locale) {
                    data += '&locale={0}'.format(form.template.locale);
                }
                $scope.flags.loading = true;
                if (form.deliveryMethod === 'SMS') {
                    data += '&canvasOwnerId=' + form.fromPhone.canvasOwnerId;
                    data += '&canvasChannelKey=' + form.fromPhone.canvasChannelKey;
                    addSms(data, form, index);
                } else {
                    addMessage(data, form, index);
                }
            };

            $scope.getNotesCount = function (fastRead) {
                var params = {};
                if (fastRead || $scope.readMode === 0) { params.readMode = 0; }

                if ($scope.perms.APPLICATION_NOTE_COUNT_GET) {
                    candidates.getNotesCount($routeParams.applicationId, params, function (data) {
                        if (data.msgInfo === $scope.status.OK) {
                            $scope.savedNotes = data.noteCount.saved;
                            $scope.sentNotes = data.noteCount.sent;
                            updateNotesCount($scope.savedNotes + $scope.sentNotes);
                        }
                    });
                }
            };

            $scope.getMessagesCount = function (fastRead) {
                var params = {};
                if (fastRead || $scope.readMode === 0) {
                    params.readMode = 0;
                }

                if ($scope.perms.APPLICATION_MESSAGE_COUNT_GET) {
                    candidates.getMessagesCount($routeParams.applicationId, params, function (data) {
                        if (data.msgInfo === $scope.status.OK) {
                            $scope.receivedMessages = data.messageCount.recieved;
                            $scope.sentMessages = data.messageCount.sent;
                            updateMessagesCount($scope.receivedMessages + $scope.sentMessages);
                        }
                    });
                }
            };

            jvHireBroadcastSVC.subscribe('getEvaluationsCount', function () {
                $scope.getEvaluationsCount(true);
            });

            $scope.getEvaluationsCount = function (fastRead) {
                var params = {};
                if (fastRead || $scope.readMode === 0) { params.readMode = 0; }

                if ($scope.perms.INTERVIEW_EVALUATIONS_GET || $scope.perms.VIDEO_ALL_EVALUATIONS) {
                    candidates.getEvaluationsCount($routeParams.applicationId, params, function (data) {
                        if (data.msgInfo === $scope.status.OK) {
                            $scope.submittedEvaluationsCount = data.evaluationsCount.submittedEvaluations + data.evaluationsCount.submittedVideoEvaluations;
                            updateEvaluationsCount($scope.submittedEvaluationsCount);
                        }
                    });
                }
            };

            $scope.getNotes = function (offset, count, callback, fastRead) {
                $scope.flags.loading = true;
                var data = {
                    offset: offset,
                    count: count
                };
                if (offset === 0 && count === $scope.page.count) {
                    $scope.notes = [];
                }
                if (fastRead === 0) {
                    data.readMode = 0;
                }

                if ($scope.jump === 'saved') {
                    data.sent = false;
                    if (!$scope.savedNotes) {
                        $scope.notes = [];
                        return;
                    }
                } else if ($scope.jump === 'sent') {
                    data.sent = true;
                    if (!$scope.sentNotes) {
                        $scope.notes = [];
                        return;
                    }
                }
                candidates.getNotes($routeParams.applicationId, data, function (data) {
                    if (data.msgInfo === $scope.status.OK) {
                        if (callback) {
                            callback(data.messageDataItem);
                        }
                        else {
                            if (data.messageDataItem) {
                                if ($scope.flags.add === false) {
                                    if ($scope.notes.length === data.messageDataItem.length) {
                                        $scope.notes = data.messageDataItem;
                                    }
                                    else {
                                        $scope.notes = data.messageDataItem.concat($scope.notes);
                                    }
                                }
                                else {
                                    $scope.notes = data.messageDataItem.concat($scope.notes);
                                    $scope.flags.add = false;
                                }
                                $rootScope.$broadcast('load_application_notes', $scope.notes);
                            }
                        }
                    }
                    $scope.processing = $scope.flags.loading = false;
                });
            };

            $scope.getMessages = function (offset, count, callback, fastRead) {
                $scope.flags.loading = true;
                var data = {
                    offset: offset,
                    count: count
                };
                if (offset === 0 && count === $scope.page.count) {
                    $scope.messages = [];
                }
                if (fastRead === 0) {
                    data.readMode = 0;
                }

                if ($scope.jump === 'received') {
                    data.sent = false;
                    if (!$scope.receivedMessages) {
                        $scope.messages = [];
                        return;
                    }
                } else if ($scope.jump === 'sent') {
                    data.sent = true;
                    if (!$scope.sentMessages) {
                        $scope.messages = [];
                        return;
                    }
                }
                candidates.getMessages($routeParams.applicationId, data, function (data) {
                    if (data.msgInfo === $scope.status.OK) {
                        if (callback) {
                            callback(data.messageDataItem);
                        } else {
                            if (data.messageDataItem) {
                                $scope.messages = data.messageDataItem.concat($scope.messages);
                                $rootScope.$broadcast('load_application_messages', $scope.messages);
                            }
                        }
                    }
                    $scope.processing = $scope.flags.loading = false;
                });
            };

            $scope.updateForm = function (form, formTemplates) {
                $scope.templateRequested = form.template;
                if (!form.template || form.template === '') {
                    form.subject = '';
                    form.content = '';
                    form.contentText = '';
                    return;
                } else {
                    angular.forEach(formTemplates, function (template) {
                        if ($scope.templateRequested === template.eid || $scope.templateRequested['eid'] === template.eid) {
                            form.subject = template.subject;
                            form.content = template.body;
                            form.contentText = template.body;
                        }
                    });
                }
            };

            var updateAgencyTemplatePrivate = function (template) {
                if ($scope.messageQForm.templateType === 'company') {
                    if (template === 'agency') {
                        $scope.quickForm.loadAgencyTemplate = 'agency';
                        $scope.agencyMessageTemplates = $scope.select2Options.setTemplates($scope.quickForm.message.agencyMessageTemplates);
                        angular.forEach($scope.agencyMessageTemplates, function (template) {
                            if (template['default']) {
                                $scope.defaultMessageTemplate = template;
                                $timeout(function () {
                                    $scope.messageQForm.template = $scope.defaultMessageTemplate;
                                }, SELECT2_LAZY_LOAD_TIME);
                                var content = template.body ? template.body : '';
                                $scope.messageQForm.subject = template.subject ? template.subject : '';
                                $scope.messageQForm.content = content;
                                $scope.messageQForm.contentText = content;
                            }
                        });
                    } else if (template === 'candidate') {
                        $scope.quickForm.loadAgencyTemplate = 'candidate';
                        $scope.messageTemplates = $scope.select2Options.setTemplates($scope.quickForm.message.templates);
                        angular.forEach($scope.messageTemplates, function (template) {
                            if (template['default']) {
                                $scope.defaultMessageTemplate = template;
                                $timeout(function () {
                                    $scope.messageQForm.template = $scope.defaultMessageTemplate;
                                }, SELECT2_LAZY_LOAD_TIME);
                                var content = template.body ? template.body : '';
                                $scope.messageQForm.subject = template.subject ? template.subject : '';
                                $scope.messageQForm.content = content;
                                $scope.messageQForm.contentText = content;
                            }
                        });
                    }
                }
                else if ($scope.messageQForm.customTemplate) {
                    getCustomMessageTemplate($scope.messageQForm.customTemplate);
                }
            };

            $scope.updateAgencyTemplate = function (template) {
                updateAgencyTemplatePrivate(template);
            };

            var getPhoneNoList = function () {
                jvCandidatesService.getPhoneNoList({
                    data: {}
                }, function (resp) {
                    if (resp && resp.data && resp.data.phoneList && resp.data.phoneList.content) {
                        var phoneListContent = resp.data.phoneList.content;
                        var fromObj = angular.copy($scope.messageQForm.fromPhoneData);
                        fromObj.data.optionsValues = [];
                        for (var phone of phoneListContent) {
                            // phoneForDisplay
                            const phoneData = {
                                label: phone.channelKey,
                                checked: true,
                                displayName: phone.owner.displayName + ' ' + phone.phoneForDisplay,
                                value: phone.channelKey,
                                canvasOwnerId: phone.owner.ownerRefKey,
                                canvasChannelKey: phone.channelKey
                            };
                            fromObj.data.optionsValues.push(phoneData);
                        }
                        $scope.messageQForm.fromPhoneData.data.optionsValues = fromObj.data.optionsValues;
                        $scope.messageQForm.fromPhone = fromObj.data.optionsValues[0];
                    }
                });
            };

            //@param noDefault if set it wont prefill the default template
            $scope.getMessageTemplates = function (inReplyCallback, noDefault) {
                var deferred = $q.defer();
                $scope.flags.loading = true;
                var params = {};
                if ($scope.readMode) {
                    params.readMode = 0;
                }
                if ($scope.messageQForm.sendUser === 'false' && $scope.messageQForm.deliveryMethod !== 'SMS') {
                    params.sendAnonymously = true;
                }
                if ($scope.appDetails.enableSMSMessaging) {
                    params.enableSMSMessaging = $scope.appDetails.enableSMSMessaging;
                }
                if ($scope.messageQForm.deliveryMethod) {
                    params.messageType = $scope.messageQForm.deliveryMethod;
                }
                candidates.getMessageTmpl($routeParams.applicationId, params, function (data) {
                    if (data.msgInfo === $scope.status.OK) {
                        deferred.resolve(data);
                        $scope.quickForm.message = data;
                        $scope.candidatePhone = $scope.quickForm.message.candidatePhone;
                        $scope.candidateSMSConsent = $scope.quickForm.message.candidateSMSConsent;
                        if ($scope.quickForm.message.isAgencyCandidate && params.messageType !== 'SMS') {
                            $scope.messageQForm.templates = $scope.quickForm.message.agencyMessageTemplates;
                            $scope.agencyMessageTemplates = $scope.select2Options.setTemplates($scope.quickForm.message.agencyMessageTemplates);

                            if (!noDefault) {
                                // set default selected template
                                angular.forEach($scope.agencyMessageTemplates, function (template) {
                                    if (template['default']) {
                                        $scope.defaultMessageTemplate = template;
                                        $timeout(function () {
                                            setFlyoutTemplate($scope.messageQForm, template);
                                        }, SELECT2_LAZY_LOAD_TIME);
                                        $scope.messageQForm.setMessageTeplate = true;
                                    }
                                });
                            }
                        } else {
                            $scope.messageQForm.templates = $scope.quickForm.message.templates;
                            $scope.messageTemplates = $scope.select2Options.setTemplates($scope.quickForm.message.templates);

                            if (!noDefault) {
                                // set default selected template
                                angular.forEach($scope.messageTemplates, function (template) {
                                    if (template['default']) {
                                        $scope.defaultMessageTemplate = template;
                                        $scope.messageQForm.template = $scope.defaultMessageTemplate;
                                        $scope.messageQForm.subject = template.subject ? template.subject : '';
                                        var content = template.body ? template.body : '';
                                        $scope.messageQForm.content = content;
                                        $scope.messageQForm.contentText = content;
                                        $scope.messageQForm.setMessageTeplate = true;
                                    }
                                });
                            }
                        }
                        //$scope.messageTemplates = $scope.quickForm.message.templates;
                        //setting the flag to show agency/candidate templates
                        if ($scope.quickForm.message.isAgencyCandidate && $scope.messageQForm.deliveryMethod !== 'SMS') {
                            $scope.quickForm.loadAgencyTemplate = 'agency';
                        } else {
                            $scope.quickForm.loadAgencyTemplate = 'candidate';
                        }
                        if (inReplyCallback) {
                            inReplyCallback();
                        }
                        $timeout(function () {
                            // reset form state due to angular ui bug
                            // and listen for pristine state changes
                            $scope.$broadcast('setMessageFormPristine');
                            $scope.$on('messageFormPristine', function (e, val) {
                                $scope.flags.messages.inDraft = !val;
                            });
                        }, 100); // delay for select2 rendering
                        if (params.messageType === 'SMS') {
                            getPhoneNoList();
                        }
                    }
                    $scope.flags.loading = false;
                });
                return deferred.promise;
            };

            //setting noDefault to true will make sure we fetch templates but dont set the default template in the drop down
            //This is used for notes reply /edit use cases
            $scope.getNoteTemplates = function (noDefault) {
                var deferred = $q.defer();
                var params = {};
                if ($scope.readMode) {
                    params.readMode = 0;
                }
                candidates.getNoteTmpl($routeParams.applicationId, params, function (data) {
                    $scope.flags.loading = false;
                    if (data.msgInfo === $scope.status.OK) {
                        deferred.resolve(data);
                        $scope.noteQForm.templates = $scope.noteTemplates_Copy = angular.copy(data.templates);
                        $scope.noteTemplates = $scope.select2Options.setTemplates(data.templates);

                        if (!noDefault) {
                            // set default selected template
                            angular.forEach($scope.noteTemplates, function (template) {
                                if (template['default']) {
                                    $scope.defaultNoteTemplate = template;
                                    setFlyoutTemplate($scope.noteQForm, template);
                                }
                            });
                        }

                        $timeout(function () {
                            // reset form state due to angular ui bug
                            // and listen for pristine state changes
                            $scope.$broadcast('setNoteFormPristine');
                            $scope.$on('noteFormPristine', function (e, val) {
                                $scope.flags.notes.inDraft = !val;
                            });
                        }, 100); // delay for select2 rendering
                    }
                });
                return deferred.promise;
            };

            $scope.employeeFormatter = function (data) {
                var terms = {};
                angular.forEach(data.employees, function (value) {
                    terms[value.EId] = value.firstName + ' ' + value.lastName;
                    if (value.email) {
                        terms[value.EId] += ' [' + value.email + ']';
                    }
                });
                return terms;
            };

            $scope.initQuickForms = function () {
                // make sure forms are pristine after loading, angular ui likes to make select2 dirty for no reason
                $timeout(function () {
                    $scope.$broadcast('setNoteFormPristine');
                    $scope.$broadcast('setMessageFormPristine');
                }, 100);
            };

            jvHireBroadcastSVC.subscribe('openFlyout', function (event, eventData) {
                if (eventData.flyoutData.isNoteReply) {
                    //remove the content since its a note reply  and open the flyout
                    eventData.flyoutData.content = '';
                    $scope.showQForm(eventData.flyoutType, null, eventData.flyoutData, true, true);
                } else {
                    $scope.showQForm(eventData.flyoutType, null, eventData.flyoutData, true);
                }
            });

            $scope.showQForm = function (name, fetchDefaultAttachments, flyoutObject, flyoutEditMode, isNoteReply) {
                $scope.initQuickForms();
                $scope.loadtinymce = true;
                $scope.initQuickForms = angular.noop;
                $scope.flags.noAnimate = $scope.flags.quickForms !== false;
                $scope.flags.quickForms = name;
                if (flyoutObject && flyoutObject.objectEId && !isNoteReply) {
                    $scope.flyoutObjectEId = flyoutObject.objectEId;
                }

                if (name === 'message' && !$scope.flags.messages.inDraft && $scope.openFlyout !== 'message' && !flyoutEditMode) {
                    $scope.fetchTemplates(name);
                } else if (name === 'note' && !$scope.flags.notes.inDraft && $scope.openFlyout !== 'note' && !flyoutEditMode) {
                    $scope.fetchTemplates(name);
                }

                switch (name) {
                    case 'message':
                        $('.uploader-error').hide();
                        $scope.flags.msgMandetoryFlag = false;
                        if (flyoutEditMode) {
                            $scope.flyoutEditMode = true;
                            $scope.getMessageTemplates(null, true).then(function () {
                                setFlyoutTemplate($scope.messageQForm, flyoutObject);
                            });
                        }
                        break;
                    case 'note':
                        $('.uploader-error').hide();
                        $scope.flags.noteMandetoryFlag = false;
                        if (flyoutEditMode) {
                            $scope.flyoutEditMode = true;
                            $scope.getNoteTemplates(true).then(function () {
                                setFlyoutTemplate($scope.noteQForm, flyoutObject, isNoteReply);
                            });
                        }
                        break;
                    default:
                        break;
                }
                $scope.flyoutOpen = true;
                $scope.openFlyout = name;

                // Used when need to add resume as attachement by default - from Application Tab
                if (fetchDefaultAttachments) {
                    $scope.getCandidateFiles(true);
                }
            };

            $scope.openJVIMWidget = function () {
                jvHireUrlService.openJVIMFloatingWidget(__applicationDetails.details.application.candidateEId, $scope._currentUser.email);
            };

            $scope.voidOffer = function () {
                var data = $scope.candAppRej.content;
                candidates.voidESigOfferLetter($routeParams.applicationId, data, function (res) {
                    if (res.msgInfo === 200) {
                        $scope.showMsg('CANDIDATE_VOIDED_OFFER_LETTER');
                        $scope.candAppRej.approveCand = false;
                        $scope.updateWorkflowActions();
                    } else {
                        if (res.msgInfo === 401) {
                            $scope.showMsg('CANDIDATE_OFFER_GENERATION_ERROR_NO_SOCIAL_PROFILE');
                        } else if (res.msgInfo === 417) {
                            $scope.showMsg('CANDIDATE_OFFER_GENERATION_ERROR_SIGNER_DOESNT_EXIST');
                        } else if (res.msgInfo === 412) {
                            $scope.showMsg('CANDIDATE_OFFER_GENERATION_ERROR_SIGNER_NOT_SENT');
                        } else if (res.msgInfo === 406) {
                            $scope.showMsg('CANDIDATE_OFFER_GENERATION_ERROR_USER_NOT_AUTHORIZED');
                        } else if (res.msgInfo === 418) {
                            $scope.showMsg('CANDIDATE_OFFER_GENERATION_ERROR_USER_NOT_SENDER');
                        } else if (res.msgInfo === 419) {
                            $scope.showMsg('CANDIDATE_VOID_OFFER_ERROR_OFFER_STATE');
                        } else {
                            $scope.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                        }
                    }
                });
            };

            $scope.offerApproveReject = function (skip) {
                $scope.flags.loading = true;
                $scope.candAppRej.disableSubmit = true;
                var data = {};
                if (skip) {
                    data = {
                        skipApprover: true
                    };
                } else {
                    data = {
                        reject: !$scope.candAppRej.isOptional
                    };
                    if ($scope.candAppRej.content) {
                        data.notes = $scope.candAppRej.content;
                    }
                    if (!$scope.candAppRej.isOptional && (!$scope.candAppRej.content || $scope.candAppRej.content.trim() === '')) {
                        $scope.candAppRej.context = i18n.ENTER_NOTE;
                        $scope.candAppRej.content = '';
                        $scope.candAppRej.maxLength = false;
                        $scope.candAppRej.checkContent = true;
                        $scope.candAppRej.approveCand = true;
                        return false;
                    }
                }

                candidates.offerAprroveActions($routeParams.applicationId, data, function (res) {
                    $scope.flags.loading = false;
                    $scope.candAppRej.disableSubmit = false;
                    if (res.msgInfo === 200) {
                        if (skip) {
                            $scope.showMsg('APPROVER_SKIPPED');
                        } else {
                            if ($scope.candAppRej.isOptional) {
                                $scope.showMsg('OFFER_APPROVED');
                            } else {
                                $scope.showMsg('OFFER_REJECTED');
                            }
                        }
                        $scope.candAppRej.approveCand = false;
                        $scope.updateWorkflowActions();
                    }
                });
            };

            $scope.candAppRej.submit = function () {
                switch ($scope.candAppRej.modal) {
                    case 'approve_cand':
                        $scope.candApproveReject();
                        break;
                    case 'reject_cand':
                        $scope.candApproveReject();
                        break;
                    case 'approveOffer':
                        $scope.offerApproveReject(false);
                        break;
                    case 'rejectOffer':
                        $scope.offerApproveReject(false);
                        break;
                    case 'voidOffer':
                        $scope.voidOffer();
                        break;
                    default:
                }
            };

            $scope.candAppRej.cancelModal = function () {
                $scope.candAppRej.approveCand = false;
                $scope.candAppRej.content = '';
            };

            $scope.candApproveRej = function (stateId, val) {
                $scope.workflowStateId = stateId;
                $scope.candAppRej.context = i18n.ENTER_NOTE;
                $scope.candAppRej.maxLength = false;
                $scope.candAppRej.approveCand = true;
                $scope.candAppRej.checkContent = false;
                if (val) {
                    $scope.candAppRej.title = i18n.APPROVE_CANDIDATE;
                    $scope.candAppRej.button = i18n.APPROVE;
                    $scope.candAppRej.modal = 'approve_cand';
                } else {
                    $scope.candAppRej.title = i18n.REJECT_CANDIDATE;
                    $scope.candAppRej.button = i18n.REJECT;
                    $scope.candAppRej.modal = 'reject_cand';
                }
                $scope.candAppRej.isOptional = val;
            };

            $scope.candSendToOnboarding = function (stateId, onBoardingEvent) {
                var data = {};
                data.applicationEId = $routeParams.applicationId;
                data.workflowStateId = stateId;
                data.appDetails = $scope.appDetails;
                data.onBoardingEvent = onBoardingEvent;
                $rootScope.$emit('showSendToOnboardingModal', data);
            };

            $scope.stopJobviteOnboarding = function (stateId, jobviteOnboardingStatus) {
                var data = {};
                data.applicationEId = $routeParams.applicationId;
                data.workflowStateId = stateId;
                data.appDetails = $scope.appDetails;
                data.jobviteOnboardingStatus = jobviteOnboardingStatus;
                $rootScope.$emit('showStopOnboardingModal', data);
            };

            $scope.messageOrchestrator = function (jobviteOnboardingStatus) {
                $rootScope.$emit('messageOrchestrator', jobviteOnboardingStatus);
            };

            $scope.candApproveReject = function () {
                var data = {
                    approve: $scope.candAppRej.isOptional
                };

                if ($scope.candAppRej.content) {
                    data.notes = $scope.candAppRej.content;
                }

                if (!$scope.candAppRej.isOptional && (!$scope.candAppRej.content || $scope.candAppRej.content.trim() === '')) {
                    $scope.candAppRej.context = i18n.ENTER_NOTE;
                    $scope.candAppRej.maxLength = false;
                    $scope.candAppRej.checkContent = true;
                    $scope.candAppRej.approveCand = true;
                } else {
                    candidates.candAppRejHM($routeParams.applicationId, data, function (res) {
                        if (res.msgInfo === 200) {
                            if ($scope.candAppRej.isOptional) {
                                $scope.showMsg('CANDIDATE_APPROVED');
                            } else {
                                $scope.showMsg('CANDIDATE_REJECTED');
                            }
                            $scope.candAppRej.approveCand = false;
                            $scope.candAppRej.disableSubmit = false;
                            $scope.candAppRej.content = '';
                            $scope.updateWorkflowActions();
                            if ($scope.activeTab('notes')) {
                                $scope.getNotes(0, 1);
                            }
                            $scope.getNotesCount();
                        }
                    });
                }
            };

            $scope.redirectToListPage = function () {
                $window.location.href = jvHireUrlService.getCandidateListPageUrl();
            };

            $scope.restrictedCandidateModal = {
                show: false
            };

            var showRestrictedWorkflowStateModals = function () {
                $scope.templates = TemplateLoader.register({
                    restrictedCandidateModal: '/jhire/modules/candidates/modals/candidateRestricted.html'
                });

                TemplateLoader.load('restrictedCandidateModal').then(function () {
                    $scope.restrictedCandidateModal.show = true;
                });
            };

            $scope.updateWorkflowActions = function (newVal) {
                $scope.addLoading('candidates.updateWorkflowActions');
                if (newVal) {
                    $scope.fromGoto = true;
                    var data = {
                        applicationWorkflowStepId: newVal.EId
                    };

                    candidates.updateWorkflowActions($routeParams.applicationId, data, function (res) {
                        $scope.removeLoading('candidates.updateWorkflowActions');
                        if (res.msgInfo === $scope.status.OK || res) {
                            if (res.isRestrictedWorkflowState) {
                                showRestrictedWorkflowStateModals();
                                return;
                            }
                            $scope.getApplicationDetails(true);
                            $rootScope.fastRead.summary = true;
                        }
                    }, function () {
                        $scope.flags.loading = false;
                    });
                } else {
                    $scope.removeLoading('candidates.updateWorkflowActions');
                    $scope.getApplicationDetails(true);
                }
            };

            /**
             * @method updateWorkFlowStep
             * @description Updates the workflow dropdown
             * @params {object} newVal - current workflow value
             */
            var updateWorkFlowStep = function (newVal) {
                if (newVal === null) {
                    resetApplicationWorkflow();
                }
                if (newVal && !$.isEmptyObject(newVal) && !newVal.reset) {
                    //Totango. Called when there is a change to workflow step.
                    jvTotango.track('Change Application Status', 'Recruiter');
                    $scope.flags.loading = true;
                    newVal = angular.fromJson(newVal);
                    var workflow = newVal.metaModel.candidateState;

                    if (workflow.predefinedKind) {
                        if (workflow.predefinedKind === 'SUBMITTED_TO_HIRING_MANAGER') {
                            $scope.getSubmitToHM(workflow.EId);
                        } else if (workflow.predefinedKind === 'PENDING_APPROVAL') {
                            $scope.offer = angular.extend({
                                createMode: true
                            }, $scope.offer);
                            $scope.generateOffer(workflow.EId);
                        } else if (workflow.predefinedKind === 'OFFER_GENERATION') {
                            $scope.generateViewOfferLetter(workflow.EId, false);
                        } else if (workflow.predefinedKind === 'OFFER_ACCEPTED') {
                            window.open('../requisitions/addHire_close.html#/offerAccept/' + $routeParams.applicationId + '/' + workflow.EId, '_self');
                        } else if (workflow.predefinedKind === 'APPROVED_BY_HIRING_MANAGER') {
                            $scope.flags.loading = false;
                            $scope.candApproveRej(workflow.EId, true);
                        } else if (workflow.predefinedKind === 'REJECTED_BY_HIRING_MANAGER') {
                            $scope.flags.loading = false;
                            $scope.candApproveRej(workflow.EId, false);
                        } else if (workflow.predefinedKind === 'REJECTED') {
                            $scope.rejectCandTrigger();
                        } else if (workflow.predefinedKind === 'OFFER_REJECTED') {
                            if ($scope.properties.offerDispositionFormEnabled) {
                                $scope.showOfferDispositionForm(workflow.EId);
                            } else {
                                $scope.updateWorkflowActions(workflow);
                            }
                        } else {
                            $scope.updateWorkflowActions(workflow);
                        }
                    } else {
                        //VA: video modal popup should show up as soon as the workflow moves to video screen.
                        if (workflow.kind === 'VIDEO_SCREEN' && properties.videoEnabled === 'true') {
                            // send the workflow step id and the workflow step so that it prefills the questionnaire in the modal.
                            $scope.sendVideoInterview(workflow.EId, workflow.kind, function () {
                                $scope.updateWorkflowActions(workflow);
                            });
                        }
                        else if (workflow.kind === 'PRE_OFFER_DATA_COLLECTION' || workflow.kind === 'POST_OFFER_DATA_COLLECTION') {
                            $scope.getOfferDataCollection(workflow.EId, workflow.kind);
                        }
                        //Move To - OnBoarding-Jobvite state
                        else if (workflow.kind === 'ONBOARDING_JOBVITE') {
                            $scope.flags.loading = false;
                            $scope.candSendToOnboarding(workflow.EId, 'send');
                        }
                        else {
                            $scope.updateWorkflowActions(workflow);
                        }
                    }
                }
            };

            /**
             * @method confirmWorkFlowStepChange
             * @description confirms the action based on the user input
             * @params {object} newVal - current workflow value
             */
            var confirmWorkFlowStepChange = function (newVal) {
                if (window.confirm('\n' + i18n.NAV_AWAY_WARNING_MESSAGE + '\n' + i18n.NAV_AWAY_CONFIRM)) {
                    updateWorkFlowStep(newVal);
                    $rootScope.isFormEditInProgress = false;
                    $scope.activeWorkflowStep = newVal;
                    var workflowObj = JSON.parse(newVal);
                    if (workflowObj.metaModel.candidateState.kind && workflowObj.metaModel.candidateState.predefinedKind !== 'PENDING_APPROVAL') {
                        jvHireUrlService.loadCandidateDetailsTab('workflow', $routeParams.applicationId);
                    }
                } else {
                    setTimeout(function () {
                        if (!$scope.$$phase || !$scope.$root.$$phase) {
                            $scope.checkForPopup = false;
                            $('#workflowDropdownSelect').select2('val', $scope.activeWorkflowStep).trigger('change');
                        }
                    });
                }
            };

            /**
             * @method workflowStep
             * @description Watches the change in the workflow steps dropdown
             * Check for open forms and show appropriate pop for navigating away
             * @params {object} newVal - current workflow value
             */
            $scope.$watch('workflowStep', function (newVal) {
                $scope.$broadcast('isFormEditInProgessEvt');
                if (newVal !== '' && $rootScope.isFormEditInProgress && $scope.checkForPopup) {
                    confirmWorkFlowStepChange(newVal);
                } else if (!$scope.checkForPopup) {
                    $scope.checkForPopup = true;
                } else if (newVal) {
                    updateWorkFlowStep(newVal);
                    $scope.checkForPopup = true;
                    $scope.activeWorkflowStep = newVal;
                }
            });

            /**
             * SUBMIT TO HM
             */
            $scope.getSubmitToHM = function (stateId) {
                $scope.subitHMId = stateId;

                $scope.flags.loading = false;
                var data = {
                    appIds: [$routeParams.applicationId],
                    stateId: stateId,
                    jobEId: $scope.appDetails.application.job.EId,
                    name: $scope.appDetails.application.candidate.firstName + ' ' + $scope.appDetails.application.candidate.lastName
                };
                $rootScope.$broadcast('showsubmitToHMModal', data);
            };

            // OFFER REJECTION FORM (Show Offer Disposition Form)
            $scope.showOfferDispositionForm = function (stateEId) {
                var data = {
                    stateEId: stateEId,
                    applicationEId: [$routeParams.applicationId]
                };
                $rootScope.$broadcast('showOfferRejectModal', data);
            };

            jvHireBroadcastSVC.subscribe('showOfferRejectModalSuccess', function (event, dispositionEId) {
                $scope.appDetails.application.dispositionEId = dispositionEId;
                $scope.getApplicationDetails(true);
                if ($scope.activeTab('workflow')) {
                    $scope.getWorkflowSummary();
                }
                $scope.showMsg('OFFER_REJECTED');
            });

            $scope.$watch('message.newTemplate', function (newVal) {
                if (newVal) {
                    for (var template in $scope.message.templates) {
                        if ($scope.message.templates[template].EId === newVal) {
                            $scope.message.subject = $scope.message.templates[template].subject;
                            $scope.message.content = $scope.message.templates[template].body;
                            break;
                        }
                    }
                } else {
                    $scope.message.subject = '';
                    $scope.message.content = '';
                }
            });

            /**
             * Get PreOffer and PostOffer Data for Compliance
             */
            $scope.getOfferDataCollection = function (stateId, step) {
                if ($scope.appDetails && $scope.appDetails.application && $scope.appDetails.application.candidate && !$scope.appDetails.application.candidate.email) {
                    $scope.showMsg('CANDIDATE_MSG_NO_VALID_EMAIL');
                    $scope.flags.loading = false;
                    return;
                }
                $scope.offerMessage.stateId = stateId;
                $scope.offerMessage.modal = step;
                $scope.offerMessage.checkTo = false;
                $scope.offerMessage.checkText = { 'subject': false, 'content': false };
                $scope.offerMessage.title = i18n.OFCCP_OFFER;
                if (step === 'PRE_OFFER_DATA_COLLECTION') {
                    candidates.getPreOfferData($routeParams.applicationId, stateId, function (res) {
                        $scope.flags.loading = false;
                        $scope.offerMessage.formCompleted = false;
                        $scope.offerMessage.formSent = false;
                        $scope.offerMessage.locale = res.preOfferData.model.preOfferFormInfo.locale;
                        if (res.preOfferData && res.preOfferData.model && res.preOfferData.model.preOfferFormInfo) {
                            $scope.offerMessage.content = res.preOfferData.model.preOfferFormInfo.content;
                            $scope.offerMessage.subject = res.preOfferData.model.preOfferFormInfo.subject;
                            $scope.offerMessage.to = res.preOfferData.model.preOfferFormInfo.to;
                            if (res.preOfferData.model.preOfferFormInfo.forms) {
                                $scope.offerMessage.forms = res.preOfferData.model.preOfferFormInfo.forms;
                            }
                        } else if (res.preOfferData.model.preOfferOfccpCompleted) {
                            $scope.offerMessage.formCompleted = res.preOfferData.model.preOfferOfccpCompleted;
                        } else if (res.preOfferData.model.preOfferOfccpEmailSent) {
                            $scope.offerMessage.formSent = res.preOfferData.model.preOfferOfccpEmailSent;
                        }

                        $scope.complianceModal = true;
                    });
                }
                else if (step === 'POST_OFFER_DATA_COLLECTION') {
                    candidates.getPostOfferData($routeParams.applicationId, stateId, function (res) {
                        $scope.flags.loading = false;
                        $scope.offerMessage.formCompleted = false;
                        $scope.offerMessage.formSent = false;
                        $scope.offerMessage.locale = res.postOfferData.model.postOfferFormInfo.locale;
                        if (res.postOfferData && res.postOfferData.model && res.postOfferData.model.postOfferFormInfo) {
                            $scope.offerMessage.content = res.postOfferData.model.postOfferFormInfo.content;
                            $scope.offerMessage.subject = res.postOfferData.model.postOfferFormInfo.subject;
                            $scope.offerMessage.to = res.postOfferData.model.postOfferFormInfo.to;
                            if (res.postOfferData.model.postOfferFormInfo.forms) {
                                $scope.offerMessage.forms = res.postOfferData.model.postOfferFormInfo.forms;
                            }
                        } else if (res.postOfferData.model.postOfferOfccpCompleted) {
                            $scope.offerMessage.formCompleted = res.postOfferData.model.postOfferOfccpCompleted;
                        } else if (res.postOfferData.model.postOfferOfccpEmailSent) {
                            $scope.offerMessage.formSent = res.postOfferData.model.postOfferOfccpEmailSent;
                        }

                        $scope.complianceModal = true;
                    });
                }
            };

            /**
             * Change Status of PreOffer and PostOffer
             */
            $scope.offerMessage.changeStatus = function () {
                $scope.flags.loading = true;
                candidates.updateOfccpStatus($routeParams.applicationId, $scope.offerMessage.stateId, function (res) {
                    if (res.msgInfo === $scope.status.OK || res.msgInfo === 0) {
                        $scope.showMsg('OFCCP_FORM_APP_STATUS_CHANGED');
                        $scope.updateWorkflowActions();
                        $scope.complianceModal = false;
                    }
                    $scope.flags.loading = false;
                }, function () {
                    $scope.flags.loading = false;
                });
            };
            /*
             * Cancel method for compliance modal
             */
            $scope.complianceCancel = function () {
                $scope.complianceModal = false;
            };
            /**
             * THIS IS TO SUBMIT TO APPROVERS FOR APPROVAL
             */
            $scope.generateOffer = function (stateId) {
                navigate('workflow-offerLetter/' + $routeParams.applicationId + '/' + stateId, 'workflow-offerLetter');
                $scope.offer = angular.extend({
                    editMode: true
                }, $scope.offer);
                $window.localStorage.setItem('offerDetails', JSON.stringify($scope.offer));
            };

            /**
             * THIS IS TO GENERATE / VIEW OFFER LETTER FOR CANDIDATE
             */
            $scope.generateViewOfferLetter = function (id, regenerate) {
                if (regenerate) {
                    navigate('workflow-generateOfferLetter/' + $routeParams.applicationId + '/' + id);
                } else {
                    if (id) {
                        navigate('workflow-generateOfferLetter/' + $routeParams.applicationId + '/' + id, 'workflow-generateOfferLetter');
                    } else {
                        navigate('workflow-generateOfferLetter/' + $routeParams.applicationId, 'workflow-generateOfferLetter');
                    }
                }
                $scope.currentTab = workflowTab;
            };

            $scope.resetCertificateData = function () {
                $scope.viewCoverPageModal = {
                    visible: false,
                    loading: false,
                    error: false
                };
                $scope.certificateFile = null;
                $scope.certificateFileName = null;
            };

            $scope.certificateFile = null;
            $scope.certificateFileName = null;

            $scope.registerDownload = function (callback) {
                $scope.downloadCallback = callback;
            };

            $scope.downloadCertificate = function () {
                $scope.downloadCallback();
            };

            $scope.viewCoverPage = function () {
                $scope.resetCertificateData();
                $scope.viewCoverPageModal.visible = true;
                $scope.viewCoverPageModal.loading = true;

                var args = {
                    applicationEId: $routeParams.applicationId
                };
                jvCandidatesService.getCoverPageFile(args, function (response) {
                    $scope.viewCoverPageModal.loading = false;
                    if (response.status === 200 && response.data && response.data.coverPage) {
                        $scope.certificateFile = `data:application/pdf;base64,${response.data.coverPage}`;
                        $scope.certificateFileName = response.data.coverPageName || 'native_esignature_coverpage.pdf';
                    } else {
                        $scope.viewCoverPageModal.error = true;
                    }
                });
            };

            /**Set of methods to support attaching files to candidate notes
             * get candidate files and format to model candFiles(ajax)
             */
            $scope.getCandidateFiles = function (isAttachFile) {
                if (!$scope.noteQForm.showFiles && angular.isUndefined($scope.noteQForm.candFiles)) {
                    $scope.flags.loading = true;
                    candidates.getCandFiles($routeParams.applicationId, null, function (data) {
                        $scope.noteQForm.candFiles = [];
                        $scope.noteQForm.clone_candFilesRef = [];
                        angular.forEach(data.candidateFiles, function (file) {
                            var candFile = {
                                id: file.EId,
                                kind: file.fileKind,
                                name: file.fileName
                            };
                            $scope.noteQForm.candFiles.push(candFile);
                            angular.copy($scope.noteQForm.candFiles, $scope.noteQForm.clone_candFilesRef);
                            if (isAttachFile && file.EId === isAttachFile) {
                                $scope.candFileCheck[file.EId] = true;
                                $scope.addToNoteAttachments(candFile, $scope.candFileCheck);
                            }
                        });

                    });
                    $scope.flags.loading = false;
                }
                if (!isAttachFile) {
                    $scope.noteQForm.showFiles = true;
                }
                if (isAttachFile && $scope.noteQForm.candFiles) {
                    for (var i = 0; i < $scope.noteQForm.candFiles.length; i++) {
                        if ($scope.noteQForm.candFiles[i].id === isAttachFile) {
                            $scope.candFileCheck[isAttachFile] = true;
                            $scope.addToNoteAttachments($scope.noteQForm.candFiles[i], $scope.candFileCheck);
                        }
                    }
                }
            };

            /**
             * adding file to attachment uploaded list and upaditing modal
             */
            $scope.addToNoteAttachments = function (file, candFileCheck) {
                if (candFileCheck[file.id]) {
                    $scope.flags.notes.inDraft = true;
                    var uploaderLoaded = $('#noteQ-Attachment-uploader ul.qq-upload-list');
                    $compile(
                        uploaderLoaded.append('<li class="qq-upload-success' + file.id + '"><span class="qq-upload-file">' + file.name + '</span><span class="qq-upload-size" style="display:inline"></span><a ng-click="deleteCandidateFilesFromNote(\'' + file.id + '\');" class="actn-delete">&nbsp;</a></li>')
                    )($scope);
                    $scope.note.attachments[file.id] = {
                        resourceInfo: {
                            eid: file.id,
                            fileKind: file.kind,
                            fileName: file.name
                        }
                    };
                    $scope.noteQForm.disableSaveFile = false;
                } else {
                    $scope.deleteCandidateFilesFromNote(file.id);
                }
            };

            /**
             * attaching delete event for attched candidate file
             */
            $scope.deleteCandidateFilesFromNote = function (fileId) {
                if ($scope.note.attachments[fileId]) {
                    delete $scope.note.attachments[fileId];
                    $('.qq-upload-success' + fileId).remove();
                    $scope.noteQForm.disableSaveFile = $scope.noteQForm.candFiles.length === $scope.noteQForm.clone_candFilesRef.length;
                    $scope.candFileCheck[fileId] = false;
                }
            };

            /**
             * cancel event for file callout, clearing model and upload list
             */
            $scope.cancelAttachFiles = function (type) {
                //we want to reset the uploader when you close the flyout or when you hit cancel on the uploadcallout. resetUploader property on the uploader directive can take only one condition.
                $('.total-uploaded').remove();
                var uploaderButton = $('.qq-uploader').children('.qq-upload-button').children('input[type="file"]');
                uploaderButton.prop('disabled', false);
                switch (type) {
                    case 'notes':
                        $scope.note.attachments = {};
                        $('#noteQ-Attachment-uploader ul.qq-upload-list').find('li').remove();
                        $scope.noteQForm.showFiles = false;
                        $scope.noteQForm.candFiles = $scope.noteQForm.clone_candFilesRef;
                        $scope.candFileCheck = {};
                        break;
                    case 'messages':
                        $scope.msg.attachments = {};
                        $('#messageQ-Attachment-uploader ul.qq-upload-list').find('li').remove();
                        $scope.messageQForm.showFiles = false;
                        break;
                    default:
                        break;
                }
            };
            /**
             * watching model to make button enable/disable
             */
            $scope.$watch('note.attachments', function (newVal) {
                if (angular.isDefined(newVal) && !$.isEmptyObject(newVal)) {
                    $scope.noteQForm.disableSaveFile = false;
                    $scope.flags.notes.inDraft = true;
                    $scope.noteQForm.disableSaveFile = true;
                }
            });

            $scope.$watch('msg.attachments', function (newval) {
                if (!$.isEmptyObject(newval)) {
                    $scope.flags.messages.inDraft = true;
                }
            });

            $scope.$watch('flags.quickForms', function (newVal) {
                //note form open
                if (newVal === 'note' && !$scope.noteQForm.template && !$scope.flyoutEditMode) {
                    $scope.noteQForm.template = $scope.defaultNoteTemplate;
                    $scope.updateForm($scope.noteQForm, $scope.noteTemplates);
                    $scope.$broadcast('setNoteFormPristine');
                    return;
                }
                //message form open
                if (newVal === 'message' && !$scope.messageQForm.template && !$scope.flyoutEditMode) {
                    $scope.messageQForm.template = $scope.defaultMessageTemplate;
                    $scope.messageQForm.templateType = 'company';
                    $scope.$broadcast('setMessageFormPristine');
                    return;
                }

                //making sure we dont set select 2 default values before the ajax endpoint comes back with data
                $timeout(function () {
                    if (newVal) {
                        //Re-setting Select2 Options when form is switched between Notes/Messages and Already fetched templates are rendered
                        $scope.select2Options.setTemplates(newVal === 'message'
                            ? $scope.quickForm.loadAgencyTemplate === 'agency'
                                ? $scope.quickForm.message.agencyMessageTemplates
                                : $scope.quickForm.message.templates

                            : $scope.noteQForm.templates);
                    }
                }, 300);

            });
            /*
             * Watching the tinymce wrapped text-area to set draft flag
             */
            $scope.$watch('noteQForm.content', function (newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    $scope.flags.notes.inDraft = true;
                }
            });

            $scope.$watch('postQForm.post', function (newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    $scope.flags.post.inDraft = true;
                }
            });

            $scope.$watch('messageQForm.content', function (newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    $scope.flags.messages.inDraft = true;
                }
            });

            $scope.$watch('messageQForm.contentText', function (newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    $scope.flags.messages.inDraft = true;
                }
            });

            $scope.$watch('appDetails.enableSMSToggle', function (newVal) {
                if (!newVal) {
                    $scope.messageQForm.deliveryMethod = 'EMAIL';
                }
            });

            $scope.$watch('messageQForm.sendUser', function (newVal, oldVal) {
                if (angular.isDefined(oldVal) && newVal !== oldVal) {
                    if ($scope.messageQForm.templateType === 'company') {
                        $scope.getMessageTemplates();
                    }
                    else if ($scope.messageQForm.customTemplate) {
                        getCustomMessageTemplate($scope.messageQForm.customTemplate);
                    }
                }
            });

            $scope.$watch('messageQForm.deliveryMethod', function (newVal, oldVal) {
                if (angular.isDefined(oldVal) && newVal !== oldVal) {
                    if (newVal === 'SMS') {
                        $scope.messageQForm.templateType = 'company';
                    }
                    if ($scope.messageQForm.templateType === 'company') {
                        $scope.getMessageTemplates();
                    }
                    else if ($scope.messageQForm.customTemplate) {
                        getCustomMessageTemplate($scope.messageQForm.customTemplate);
                    }
                    if ($scope.appDetails.application.agencyApp) {
                        updateAgencyTemplatePrivate(newVal === 'SMS' ? 'candidate' : 'agency');
                    }
                }
            });
            /**
             * If a template is unselected clear the corresponding subject  and content values from the quickform.
             */
            $scope.$watch('messageQForm.template', function (newVal) {
                if (!newVal && !$scope.flyoutEditMode) {
                    $scope.messageQForm.subject = $scope.messageQForm.content = $scope.messageQForm.contentText = '';
                }
            });

            $scope.$watch('messageQForm.templateType', function (val) {
                if (val === 'company') {
                    setFlyoutTemplate($scope.messageQForm, $scope.defaultMessageTemplate);
                    $scope.messageQForm.customTemplate = '';
                }
                else if (val === 'custom') {
                    // reset form
                    $scope.messageQForm.subject = '';
                    $scope.messageQForm.content = '';
                    $scope.messageQForm.contentText = '';
                }
            });

            $scope.$watch('messageQForm.customTemplate', function (val) {
                if (val && !$.isEmptyObject(val)) {
                    getCustomMessageTemplate(val);
                }
                else if (!$scope.flyoutEditMode && $scope.messageQForm.templateType === 'custom') {
                    // reset form
                    $scope.messageQForm.subject = '';
                    $scope.messageQForm.content = '';
                    $scope.messageQForm.contentText = '';
                }
            });

            $scope.$watch('noteQForm.template', function (newVal) {
                if (!newVal && !$scope.flyoutEditMode) {
                    $scope.noteQForm.subject = $scope.noteQForm.content = '';
                }
            });

            /**
             * Closes and  the flyout without resetting the values of the form
             */
            $scope.collapseFlyout = function () {
                $scope.flags.quickForms = false;
                $scope.flags.noAnimate = false;
                $scope.flyoutOpen = false;
                $scope.openFlyout = '';
            };

            $scope.popout = function (type) {
                var w = 1200;
                var h = 700;
                var x = screen.width / 2 - w / 2;
                var y = screen.height / 2 - h / 2;
                var randomnumber = Math.floor(Math.random() * 101);
                $scope.windowName = 'previewWindow' + randomnumber;
                //window.$windowScope = {};
                window.$windowScope = $scope;

                localStorage.removeItem('popout_data');
                window.open('../candidates/quickFormPopout.html?' + $routeParams.applicationId + '&type=' + $scope.openFlyout, $scope.windowName, 'width=' + w + ',height=' + h + ',left=' + x + ',top=' + y + ',scrollbars=0');
                if ($scope.openFlyout === 'message' && $scope.quickForm.message.isAgencyCandidate) {
                    var agencyName = encodeURIComponent($scope.quickForm.message.agency.fullName);
                    window.open('../candidates/quickFormPopout.html?' + $routeParams.applicationId + '&type=' + $scope.openFlyout + '&isAgencyCandidate=' + $scope.quickForm.message.isAgencyCandidate + '&agencyName=' + agencyName, 'previewWindow' + randomnumber, 'width=' + w + ',height=' + h + ',left=' + x + ',top=' + y + ',scrollbars=0');
                }

                $scope.previewWindow = {};
                $scope.previewWindow.applicationId = $routeParams.applicationId;

                switch (type) {
                    case 'notes':
                        $scope.previewWindow.unsavedData = $scope.noteQForm;
                        $scope.previewWindow.templates = $scope.noteQForm.templates;
                        $scope.previewWindow.attachments = $scope.note.attachments;
                        $scope.previewWindow.popoutType = 'note';
                        $scope.previewWindow.candFileCheck = angular.copy($scope.candFileCheck);
                        $scope.cancelFlyout('notes');
                        break;
                    case 'messages':
                        $scope.previewWindow.enableSMSMessaging = $scope.appDetails.enableSMSMessaging;
                        $scope.previewWindow.enableSMSToggle = $scope.appDetails.enableSMSToggle;
                        $scope.previewWindow.unsavedData = $scope.messageQForm;
                        $scope.previewWindow.candidateEmail = $scope.appDetails.application.candidate.email;
                        $scope.previewWindow.candidatePhone = $scope.appDetails.application.candidate.phone;
                        $scope.previewWindow.candidateEId = $scope.appDetails.application.candidate.EId;
                        if ($scope.quickForm.message.isAgencyCandidate) {
                            $scope.previewWindow.isAgencyCandidate = $scope.quickForm.message.isAgencyCandidate;
                            $scope.previewWindow.agencyName = $scope.quickForm.message.agency.fullName;
                            $scope.previewWindow.firstName = $scope.appDetails.application.candidate.firstName;
                            $scope.previewWindow.lastName = $scope.appDetails.application.candidate.lastName;
                            $scope.previewWindow.loadAgencyTemplate = $scope.quickForm.loadAgencyTemplate;
                        }
                        $scope.previewWindow.agencyTemplates = $scope.quickForm.message.agencyMessageTemplates;
                        $scope.previewWindow.templates = $scope.quickForm.message.templates;
                        $scope.previewWindow.attachments = $scope.msg.attachments;
                        $scope.previewWindow.popoutType = 'message';
                        $scope.previewWindow.sender = currentUserService;
                        $scope.cancelFlyout('messages');
                        break;
                    case 'tasks':
                        $scope.previewWindow.unsavedData = $scope.taskQForm;
                        $scope.previewWindow.popoutType = 'task';
                        $scope.previewWindow.firstName = $scope.appDetails.application.candidate.firstName;
                        $scope.previewWindow.lastName = $scope.appDetails.application.candidate.lastName;
                        $scope.previewWindow.jobTitle = $scope.appDetails.application.job.title;
                        $scope.cancelFlyout('tasks');
                        break;
                    default:
                        break;
                }
                $scope.previewWindow.unsavedData.applicationId = $scope.previewWindow.applicationId;
                localStorage.setItem('popout_data', JSON.stringify($scope.previewWindow));
                return false; //needed so that the parent page doesn't refresh
            };

            /**
             * Closes and Resets the values of all the elements of the flyout. Also, removes the ng-dirty status from the fields.
             */
            $scope.cancelFlyout = function (flyoutName) {
                $scope.flyoutOpen = false;
                $scope.openFlyout = '';
                $scope.flags[flyoutName].inDraft = false;
                $scope.msg.attachments = {};
                $scope.note.attachments = {};
                $('.qq-upload-success').remove();

                switch (flyoutName) {
                    case 'notes':
                        $('#noteQ-Attachment-uploader ul.qq-upload-list').find('li').remove();
                        $scope.noteQForm = {};
                        $scope.cancelAttachFiles('notes');
                        //Commenting it out since tinymce changes will go out next sprint NV
                        //$scope.noteQForm.htmlMessage = '';
                        $scope.noteQForm.template = '';
                        $scope.uploadCancel = true;
                        break;
                    case 'messages':
                        $scope.messageQForm = {
                            deliveryMethod: 'EMAIL'
                        };
                        $scope.messageQForm.template = '';
                        $scope.messageQForm.sendUser = 'true';
                        $scope.messageQForm.fromPhoneData = angular.copy(defaultPhoneData);
                        $scope.uploadCancel = true;
                        break;
                    case 'tasks':
                        $scope.taskQForm = {};
                        break;
                    case 'post':
                        $scope.postQForm = {};
                        break;
                    default:
                        break;
                }
                $scope.flags.quickForms = false;
                resetFlyoutEditMode();
            };

            /**
             * Resets thes tate maintained by the scheduler for every interaction. Interaction involves any number of
             * traversals back and forth from scheduler to messager page via the 'Back to scheduler' button.
             */

            $scope.resetScheduler = function () {
                $scope.reRenderEvents = false;
                $scope.cancelledEvents = [];
                $scope.allowPast = false;
                $scope.selLocations = {};
                $scope.interviewers = {};
                $scope.fbResources = {};
                $scope.gcalEventsCache = {};
                $scope.schedDate = new Date();
                $scope.sortIndex = 0;
                $scope.eventsCache = [];
                $rootScope.parentScope = {};
            };

            /*
             * Appends the passed in key and value pair to the path variable in the form of a url only if the value is not undefined. Prevents
             * the undefined string literal from gettting appended.
             *
             * @return returns the scope object for method chaining.
             * ToDo: See if this has to go to a global parent.
             *
             */
            $scope.appendToPath = function (path, key, value) {
                if (angular.isDefined(value)) {
                    if (!path.value) {
                        path.value = path.value + key + '=' + value;
                    } else {
                        path.value = path.value + '&' + key + '=' + value;
                    }
                }
                return $scope;
            };

            $scope.fetchTemplates = function (type) {
                if (type === 'message') {
                    $scope.getMessageTemplates();
                } else if (type === 'note') {
                    $scope.getNoteTemplates();
                }
            };

            /**
             * Workflow related method that checks if the mode is present otherwise redirects to the workflow page.
             */
            $scope.checkMode = function () {
                $scope.$parent.mode = $scope.mode || $location.search().mode;

                //If coming from advanced scheduler and its of type schedule, then set the mode.
                if (localStorage.getItem('stickyTab')) {
                    $window.localStorage.removeItem('stickyTab');
                    if ($routeParams.type === 'schedule') {
                        $scope.mode = 'schedule';
                        $scope.interviewStatus = 'Schedule';
                        $rootScope.mode = 'schedule';
                        $rootScope.interviewStatus = 'Schedule';
                    }
                }
                if (!$scope.mode) {
                    jvHireUrlService.loadCandidateDetailsTab('workflow', $routeParams.applicationId);
                }
                return $scope.mode;
            };

            $scope.setMode = function (mode, step) {
                $scope.$root.mode = $scope.mode = mode;
                if (step) {
                    $scope.$root.interviewStatus = step;
                    $scope.interviewStatus = step;
                }
            };

            /**
             * $scope.setSocialProfiles acts as the callback function for the JSONP fired in the service jv.Cand.js
             */
            window.setSocialProfiles = function (data) {
                $scope.$apply(function () {
                    $scope.spDetails = data;
                });
            };

            /*
             * Handling 'view details' of quick view modal
             */
            JV.Person = JV.Person || {};
            JV.Person.makeCallForQuickViewOverlayForApplication = function (appId) {
                var ev = window.event;
                if (ev.preventDefault) {
                    ev.preventDefault();
                } else {
                    //IE
                    ev.returnValue = false;
                }
                $scope.quickReq(appId);
            };

            /*
             * Watching PDF view on / off
             */
            jvHireBroadcastSVC.subscribe('PdfPreviewOn', function () {
                $scope.pdfViewOn = true;
            });

            $scope.addCoverFrame = function () {
                return $scope.isIE() && $scope.activeTab('application') && $scope.pdfViewOn && $scope.flyoutOpen;
            };

            //update videos count
            $scope.updateVideoCount = function (updatedCount) {
                $scope.totalVideoCompletedQuestionnaireCount = updatedCount;
                $scope.applicationTabs.filter(function (obj) {
                    if (obj.tabType === 'videos') {
                        obj.count = updatedCount;
                    }
                });
            };

            $scope.$on('showRestrictedCandidateModal', showRestrictedWorkflowStateModals);

            //used to switch tabs on candidate details page
            $scope.switchTabs = function (tabObject) {
                var tab = tabObject.tabType;
                //used to highlight active tab
                $scope.currentTab = tab;
                $scope.tabClicked = tab;
                $scope.stickyTab = tab;
                if (tab === 'evaluations') {
                    $scope.stickyTab = 'workflow';
                }
                if (tab === 'workflow') {
                    $scope.getWorkflowSummary(1);
                }
                if (!$scope.tabReorderEditMode) {
                    navigate(tabObject.href);
                }
            };
            /**
             * @Method slideRight <function>
             * @Details The method is used to add the sliding effect to the right arrow button for candidates tabs
             */
            $scope.slideRight = function () {
                var jvCandAppTabs = document.getElementsByClassName('application-tabs-slider-wrapper')[0];
                var pendingWidth = jvCandAppTabs.scrollWidth - jvCandAppTabs.clientWidth;
                if (pendingWidth > 0 && pendingWidth > 100) {
                    $scope.slideMargin = {
                        'margin-left': ($scope.Lmargin -= 100) + 'px'
                    };
                    $scope.isPrevTabArrowActive = true;
                } else if (pendingWidth > 0 && pendingWidth <= 100) {
                    $scope.slideMargin = {
                        'margin-left': ($scope.Lmargin -= pendingWidth) + 'px'
                    };
                    $scope.isNextTabArrowActive = false;
                    $scope.isPrevTabArrowActive = true;
                }
            };

            /**
             * @Method slideLeft <function>
             * @Details The method is used to add the sliding effect to the left arrow button for candidates tabs
             */
            $scope.slideLeft = function () {
                var jvCandAppTabs = document.getElementsByClassName('application-tabs-slider-wrapper')[0];
                if (($scope.Lmargin !== 0 || jvCandAppTabs.scrollWidth === jvCandAppTabs.clientWidth) && $scope.Lmargin < -100) {
                    $scope.slideMargin = {
                        'margin-left': ($scope.Lmargin += 100) + 'px'
                    };
                    $scope.isNextTabArrowActive = true;
                } else if ($scope.Lmargin >= -100) {
                    $scope.slideMargin = {
                        'margin-left': ($scope.Lmargin -= $scope.Lmargin) + 'px'
                    };
                    $scope.isPrevTabArrowActive = false;
                    $scope.isNextTabArrowActive = true;
                }
            };

            //sort application tabs by location attribute
            var sortApplicationTabs = function (propertyName) {
                return function (a, b) {
                    var value1 = a[propertyName];
                    var value2 = b[propertyName];
                    if (value1 < value2) { return -1; }
                    else if (value1 > value2) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                };
            };

            var getNewDefaultTabsForUser = function (appEId) {
                var applicationTabs = {
                    'summary':
                    {
                        showCondition: 'perms.APPLICATION_WORKFLOW_SUMMARY_GET',
                        tabType: 'summary',
                        href: 'summary/' + appEId,
                        tabOrder: 1
                    },
                    'crm':
                    {
                        showCondition: 'perms.APPLICATION_EVOLVE_SOURCE_RECRUITER',
                        tabType: 'crm',
                        href: 'crm/' + appEId,
                        tabOrder: 2
                    },
                    'application':
                    {
                        showCondition: $scope.perms.APPLICATION_RESOURCE_GET || $scope.perms.PREINTERVIEW_FORM_GET || $scope.perms.SHARE_POST,
                        tabType: 'application',
                        href: 'application/' + appEId,
                        tabOrder: 3
                    },
                    'feed':
                    {
                        showCondition: 'perms.APPLICATION_FEEDS_GET',
                        tabType: 'feed',
                        href: 'feed/' + appEId,
                        tabOrder: 4
                    },
                    'videos':
                    {
                        showCondition: 'perms.VIDEO_LIST && properties.videoEnabled',
                        tabType: 'videos',
                        href: 'videos/' + appEId,
                        count: $scope.totalVideoCompletedQuestionnaireCount || 0,
                        tabOrder: 5
                    },
                    'workflow':
                    {
                        showCondition: 'perms.APPLICATION_WORKFLOW_SUMMARY_GET',
                        tabType: 'workflow',
                        href: 'workflow/' + appEId,
                        tabOrder: 6

                    },
                    'evaluations':
                    {
                        showCondition: 'perms.VIDEO_ALL_EVALUATIONS || perms.INTERVIEW_EVALUATIONS_GET',
                        tabType: 'evaluations',
                        href: 'evaluations/' + appEId,
                        count: $scope.submittedEvaluationsCount,
                        tabOrder: 7
                    },
                    'notes':
                    {
                        showCondition: 'perms.APPLICATION_NOTES_GET',
                        tabType: 'notes',
                        href: 'notes/' + appEId,
                        count: $scope.savedNotes + $scope.sentNotes,
                        tabOrder: 8
                    },
                    'messages':
                    {
                        showCondition: 'perms.APPLICATION_MESSAGES_GET',
                        tabType: 'messages',
                        href: 'messages/' + appEId,
                        count: $scope.receivedMessages + $scope.sentMessages,
                        tabOrder: 9
                    },
                    'intelligentMessaging':
                    {
                        showCondition: 'perms.APPLICATION_IM_POST',
                        tabType: 'intelligentMessaging',
                        href: 'intelligentMessaging/' + appEId,
                        tabOrder: 10
                    },
                    'tasks':
                    {
                        showCondition: 'perms.APPLICATION_TASKS_GET',
                        tabType: 'tasks',
                        href: 'tasks/' + appEId,
                        tabOrder: 11
                    },
                    'activity':
                    {
                        showCondition: 'perms.APPLICATION_ACTIVITY_FEED_GET',
                        tabType: 'activity',
                        href: 'activity/' + appEId,
                        tabOrder: 12
                    }

                };
                return applicationTabs;
            };

            /**
             * Method - addNewlyIntroducedTabs
             * Description - This method is to introduce new tabs in future for the users who have modified and saved their tab orders.
             * the new tab will be added to the of the taborder.
             * tabType - tab type which need to be appended
             * AppEId - application Eid
             * tabCount - this is number of tabs alreday available
             **/
            var addNewlyIntroducedTabs = function (tabType, appEId, tabCount) {
                var newTabObj = getTabObject(null, tabType);
                newTabObj.href = tabType + '/' + appEId;
                newTabObj.title = i18n[newTabObj.tabType];
                newTabObj.tabOrder = tabCount + 2;
                return newTabObj;
            };

            var initializeTabs = function (appEId) {
                //get list of defaut applicationTabs
                applicationTabs = [];
                var defaultTabs = getDefaultTabsForUser(appEId);
                angular.forEach(defaultTabs, function (tab) {
                    tab.title = i18n[tab.tabType];
                    applicationTabs.push(tab);
                });

                //check if admin property is enabled
                if ($window.properties.candidateTabReorder) {
                    //get list of applicationTabs sorted by user preference
                    if (__applicationDetails.candidateTabs && angular.isArray(__applicationDetails.candidateTabs) && __applicationDetails.candidateTabs.length) {
                        //add new tabType in the array
                        var tabsToBeAdded = ['videos', 'intelligentMessaging', 'crm'];
                        applicationTabs = __applicationDetails.candidateTabs;
                        applicationTabs.forEach(function (tab) {
                            var tabObject = getTabObject(null, tab.tabType);
                            tab.href = tab.tabType + '/' + appEId;
                            tab.showCondition = tabObject.showCondition;
                            tab.title = i18n[tab.tabType];

                            if (tabsToBeAdded.includes(tab.tabType)) {
                                tabsToBeAdded.splice(tabsToBeAdded.indexOf(tab.tabType), 1);
                            }
                        });

                        if (tabsToBeAdded.length > 0) {
                            angular.forEach(tabsToBeAdded, function (tabType) {
                                var tabObj = addNewlyIntroducedTabs(tabType, appEId, applicationTabs.length);
                                applicationTabs.push(tabObj);
                            });
                        }

                    } else {
                        //if feature turned on but tabs are not re-ordered yet fetch the new default tab list
                        applicationTabs = [];
                        var newDefaultTabs = getNewDefaultTabsForUser(appEId);
                        angular.forEach(newDefaultTabs, function (tab) {
                            tab.title = i18n[tab.tabType];
                            applicationTabs.push(tab);
                        });
                    }
                }
                //sort tab list
                applicationTabs = applicationTabs.sort(sortApplicationTabs('tabOrder'));
                $scope.applicationTabs = applicationTabs;
                //on load set current tab
                var requestedUrl = $window.location.hash;
                var tabObject = getTabObject(requestedUrl);
                $scope.currentTab = tabObject.tabType;
                $scope.stickyTab = tabObject.tabType;
                if (tabObject && tabObject.tabType) {
                    $scope.currentTab = tabObject.tabType;
                } else {
                    //tab re-order enabled but not preference set
                    //if not preferece set set summary as current tab
                    $scope.currentTab = __applicationDetails.candidateTabs ? $scope.applicationTabs[0].tabType : 'summary';
                    $scope.stickyTab = $scope.currentTab;
                }
            };

            $scope.tabReorderEditMode = false;
            //enable tabReorderEditMode
            $scope.enableTabReorder = function () {
                $scope.applicationTabsCopy = angular.copy($scope.applicationTabs);
                $scope.tabReorderEditMode = true;
            };
            //cancel tab reorder
            $scope.cancelCandidateTabOrder = function () {
                $scope.applicationTabs = angular.copy($scope.applicationTabsCopy);
                $scope.tabReorderEditMode = false;
                $scope.applicationTabsCopy = [];
            };

            //save tab order
            $scope.saveCandidateTabOrder = function () {
                $scope.flags.loading = true;
                $scope.tabReorderEditMode = false;
                //filter keys that are not needed
                var filterPostData = function (obj) {
                    var filterKeys = ['href', 'showCondition', 'count'];
                    angular.forEach(filterKeys, function (keyValue) {
                        delete obj[keyValue];
                    });
                    return obj;
                };
                var tabSet = angular.copy($scope.applicationTabs);
                tabSet = tabSet.filter(filterPostData);
                var args = {
                    postData: tabSet
                };
                jvCandidatesService.saveCandidateTabOrder(args, function (response) {
                    $scope.flags.loading = false;
                    if (response && response.status === 200) {
                        $scope.tabReorderEditMode = false;
                    }
                });
            };

            //The redirection logic for video will be taken care of by the video resolve logic.
            var setCurrentTab = function () {
                if ($scope.activeTab('tasks') && $scope.perms.APPLICATION_TASKS_GET) {
                    $scope.stickyTab = 'tasks';
                } else if ($scope.activeTab('workflow') && $scope.perms.APPLICATION_WORKFLOW_SUMMARY_GET) {
                    $scope.stickyTab = 'workflow';
                } else if ($scope.activeTab('application') && $scope.perms.APPLICATION_RESOURCE_GET) {
                    $scope.stickyTab = 'application';
                } else if ($scope.activeTab('notes') && $scope.perms.APPLICATION_NOTES_GET) {
                    $scope.stickyTab = 'notes';
                } else if ($scope.activeTab('messages') && $scope.perms.APPLICATION_MESSAGES_GET) {
                    $scope.stickyTab = 'messages';
                } else if ($scope.activeTab('intelligentMessaging') && $scope.perms.APPLICATION_IM_POST) {
                    $scope.stickyTab = 'intelligentMessaging';
                } else if ($scope.activeTab('activity') && $scope.perms.APPLICATION_ACTIVITY_FEED_GET) {
                    $scope.stickyTab = 'activity';
                } else if ($scope.activeTab('feed') && $scope.perms.APPLICATION_FEEDS_GET) {
                    $scope.stickyTab = 'feed';
                } else if ($scope.activeTab('videos')) {
                    $scope.stickyTab = 'videos';
                } else if ($scope.activeTab('evaluations')) {
                    $scope.stickyTab = 'evaluations';
                } else if ($scope.activeTab('summary')) {
                    $scope.stickyTab = 'summary';
                } else if ($scope.activeTab('crm')) {
                    $scope.stickyTab = 'crm';
                }
                $scope.currentTabContent = angular.copy($scope.templates[__applicationDetails.route.url]);
                $scope.currentTab = $scope.stickyTab;
            };

            //Fetch the Linkedin/Twitter Contact Info for the candidate.
            var getContactInfo = function (candidateEid) {
                if ($scope.perms.APPLICATION_SHOW_CONTACT) {
                    jvCandidatesContactFactory.getContactInfo(candidateEid, function (data) {
                        $scope.contactInfo.linkedin = data['Linkedin'];
                        if (angular.isDefined($scope.contactInfo.linkedin) && angular.isDefined($scope.contactInfo.linkedin.name) && $scope.contactInfo.linkedin.name.indexOf('http') === -1) {
                            $scope.contactInfo.linkedin.name = 'http://' + $scope.contactInfo.linkedin.name;
                        }
                        $scope.contactInfo.twitter = data['Twitter'];
                    });
                }
            };

            var getCandidateDetails = function (applicationId, fastRead) {
                var readmode = {
                    readMode: fastRead === true ? 0 : 1
                };
                jvCandidatesViewfieldsFactory.getCandidateViewFields(applicationId, readmode, function (data) {
                    __applicationDetails.candidateDetails = data;
                    $rootScope.$broadcast('TAB_GetCandidateDetails', data);
                    angular.extend($scope.contactInfo, $scope.massageContactInfoDetails(data));
                });
            };

            var postApplicationDetails = function (data, fastRead, refreshApplications) {
                if (!$.isEmptyObject(data)) {
                    if (!data.application.read) {
                        candidates.markApplicationAsViewed(data.application.EId, function (response) {
                            if (response && response.msgInfo !== 200) {
                                $scope.showMsg('Unable to perform requested operation');
                            }
                        });
                    }
                    //Set workflow ID
                    $scope.workflowEId = data.application.job.workflowEId;
                    //Set appDetails
                    $scope.appDetails = angular.copy(data);
                    getCandidateDetails(data.application.EId, fastRead);
                    viewApplications(fastRead, data.application);
                    if ($scope.activeTab('workflow')) {
                        $scope.getWorkflowSummary(fastRead);
                    }
                    if (refreshApplications) {
                        $rootScope.$broadcast('application_details_updated', true);
                    }
                    if ($scope.appDetails && $scope.appDetails.application) {
                        setProfilePhotoUrl();
                    }
                    //Set workflowsteps
                    $scope.workflowSteps = data.applicationWorkflowSteps;
                    //Set job access flag
                    $scope.hasJobAccess = data.hasJobAccess;
                    //$scope.primaryActions holds the primary action buttons
                    $scope.primaryActions = {};
                    //Once CandidateID is retrieved, fetch the contactInfo
                    getContactInfo($scope.appDetails.application.candidateEId);
                    //construct workflow buttons
                    if (angular.isDefined($scope.appDetails.applicationWorkflowActions)) {
                        $scope.primaryActions = getPrimaryActions($scope.appDetails.applicationWorkflowActions, 1, $scope.appDetails.applicationWorkflowActions.length);
                    }
                    // Pass candidate information to Advanced Scheduler
                    localStorage.setItem('candidateDetails_toAdvancedScheduler', JSON.stringify($scope.appDetails));
                    // Set Disposition
                    if (!angular.isUndefined(data.application.dispositionEId) && (angular.isUndefined($scope.applicationDispositionEId)
                        || !angular.isUndefined($scope.applicationDispositionEId) && $scope.applicationDispositionEId) !== data.application.dispositionEId) {
                        $scope.applicationDispositionEId = angular.copy(data.application.dispositionEId);
                    }

                }
                $scope.removeLoading('candidates.getApplicationDetails');
            };

            //Should refresh all data if loading fresh, paginated or fast read
            $scope.getApplicationDetails = function (fastRead, refreshApplications) {
                var data = {};
                if (fastRead || $scope.readMode) {
                    data.readMode = 0;
                    $rootScope.fastRead.summary = true;
                } else {
                    data.readMode = $scope.readMode ? 0 : 1;
                }
                $scope.addLoading('candidates.getApplicationDetails');
                candidates.getApplicationDetails($routeParams.applicationId, $.param(data), function (response) {
                    window.__applicationDetails.details = response;
                    postApplicationDetails(response, data.readMode === 0, refreshApplications);
                });
            };

            var getPaginationData = function () {
                var searchGuid = $sessionStorage.search_guid;
                var appSearchFilters;
                if ($scope.params.mode === 'paginate' || angular.isDefined($scope.params.applicationId)) {
                    if ($scope.paging && !searchGuid) {
                        //If paging was already loaded
                        if ($scope.paging.list[$scope.paging.index] !== $routeParams.applicationId) {
                            $scope.paging.index = $scope.paging.list.indexOf($routeParams.applicationId);
                        }
                    } else {
                        //Else load pagination data
                        appSearchFilters = $sessionStorage.appSearchFilters;
                        var totalCount = $sessionStorage.search_total_count;
                        var applicationIds = $sessionStorage.search_application_ids;
                        var searchIndex = $sessionStorage.search_index;

                        var searchPage = $sessionStorage.search_page;
                        if ($scope.perms.APPLICATION_PAGINATION) {
                            //Candidate Search
                            if (!applicationIds && searchGuid) {
                                //coming from candidates profile page and have not made a call to get the application ids
                                candidates.getPaginationIds($routeParams.applicationId, searchIndex, searchGuid, searchPage, function (response) {
                                    if (response.candidateSearchResults) {
                                        paging.count = response.totalCount;
                                        paging.list = response.candidateSearchResults;
                                        //store application ids in localstorage to avoid making call again
                                        $sessionStorage.search_application_ids = response.candidateSearchResults;
                                        //store total count also in loacl storage to show on the ui
                                        $sessionStorage.search_total_count = response.totalCount;
                                        paging.index = searchIndex;
                                        //store the index of last application to use while paginating . Index will be incremented when you hit next and decremented when you hit prev
                                        $sessionStorage.search_index = searchIndex;
                                        paging.cache = {};
                                        $scope.paging = paging;
                                    }
                                });
                                $scope.backToSearchUrl = jvUrls.jhire + '/modules/candidates/list.html';
                            } else if (applicationIds && searchGuid) {
                                //coming from candidates profile page and have a cached copy in sessionStorage of application ids. So just update index here and use the list of app ids from sessionstorage
                                $scope.paging = {
                                    count: totalCount,
                                    list: applicationIds,
                                    index: searchIndex
                                };
                                $scope.backToSearchUrl = jvUrls.jhire + '/modules/candidates/list.html';

                                //Application Search
                            } else if (appSearchFilters) {
                                // coming from new application search
                                if (applicationIds) {
                                    $sessionStorage.search_index = applicationIds.indexOf($routeParams.applicationId);
                                    searchIndex = applicationIds.indexOf($routeParams.applicationId);
                                    if (searchIndex === applicationIds.length - 1 && (searchIndex !== totalCount - 1)) {
                                        appSearchFilters.page++;
                                        $window.localStorage.setItem('ngStorage-appSearchFilters', JSON.stringify(appSearchFilters));
                                        candidates.getApplicationPaginationIds($routeParams.applicationId, appSearchFilters).then(function (response) {
                                            $scope.paging = response;
                                        });
                                    } else {
                                        $scope.paging = {
                                            count: totalCount,
                                            list: applicationIds,
                                            index: searchIndex
                                        };
                                    }
                                } else {
                                    candidates.getApplicationPaginationIds($routeParams.applicationId, appSearchFilters).then(function (response) {
                                        $scope.paging = response;
                                    });
                                }
                                if (sessionStorage.getItem('reqsId')) {
                                    $scope.backToSearchUrl = jvUrls.jhire + '/modules/requisitions/tabs.html#/candidates/{0}'.format(sessionStorage.getItem('reqsId'));
                                } else {
                                    $scope.backToSearchUrl = jvUrls.jhire + '/modules/candidates/search.html#/q/{0}'.format($sessionStorage.appSearchSerializedFilters || 'return');
                                }
                            } else {
                                //Since we are using sessionStorage, this can happen in 2 cases.
                                //1) Candidate Details was opened with a new tab.
                                //2) URL incorrectly has paginate param but not coming from a list page.
                                //3) Old Search use case.
                                $log.info('Candidate Details Page with no pagination data. Possibly opened in a new tab or page is loaded not from list page or old search');
                                //Remove pagination because we do not believe the source is list page.
                                $scope.backToSearchUrl = null;
                            }
                        }
                    }
                }
            };

            var getApplicationComminicationCounts = function (appEId, readModeParam) {

                if ($scope.perms.APPLICATION_NOTES_GET || $scope.perms.APPLICATION_MESSAGES_GET) {
                    jvCandidatesService.getApplicationCommunicationCount({
                        applicationEId: appEId,
                        readMode: readModeParam === true || readModeParam === 0 ? 0 : 1
                    }, function (data) {
                        if ($scope.perms.APPLICATION_NOTE_COUNT_GET && data) {
                            $scope.savedNotes = data.noteCount.saved;
                            $scope.sentNotes = data.noteCount.sent;
                            updateNotesCount($scope.savedNotes + $scope.sentNotes);
                        }
                        if ($scope.perms.APPLICATION_MESSAGE_COUNT_GET && data) {
                            $scope.receivedMessages = data.messageCount.recieved;
                            $scope.sentMessages = data.messageCount.sent;
                            updateMessagesCount($scope.receivedMessages + $scope.sentMessages);
                        }
                    });
                }
                $scope.getEvaluationsCount($scope.readMode);
                if ($window.properties.videoEnabled === 'true') {
                    videoService.getCompleteVideoInterviewCount(appEId, function (data) {
                        $scope.updateVideoCount(data.completedVideoCount);
                    });
                }
            };

            var initialLoad = function (appEId) {
                $scope.actionPanelInitialize = true;
                $scope.params.applicationId = $routeParams.applicationId;
                $scope.applicationId = $routeParams.applicationId;
                $scope.flags.templatesInit = true;
                $scope.collapseFlyout();
                getApplicationComminicationCounts(appEId, $scope.readMode);
                resetApplicationWorkflow();
                initializeTabs(appEId);
                setCurrentTab();
                postApplicationDetails(__applicationDetails.details, $scope.readMode);
                //We need to update Totango when candidate details page is fetched.
                jvTotango.track('Review Application', 'Recruiter');
                getPaginationData();
                $('html,body').animate({ scrollTop: 0 }, 0);
            };

            jvHireBroadcastSVC.subscribe('switching_application_tab', function () {
                //Track which tab is selected. No need to internationalize
                GAService.track('Selected Tab:' + $scope.stickyTab);
                setCurrentTab();
            });

            $scope.paginate = function (direction, applicationId) {
                var appEId = applicationId;
                if (direction !== '') {
                    $sessionStorage.search_index = direction === 'next' ? $scope.paging.index + 1 : $scope.paging.index - 1;
                    appEId = $scope.paging.list[$sessionStorage.search_index].latestApplicationEId || $scope.paging.list[$sessionStorage.search_index];
                }
                GAService.track('Paginated Application:{0}'.format(applicationId));
                jvCandidateProfileFactory.resetSubscribers();
                jvHireUrlService.reloadCandidateDetails($scope.stickyTab + '/' + appEId);
            };

            angular.extend($scope.perms, __applicationDetails.views);
            GAService.track('Loading Application:{0}'.format($routeParams.applicationId));
            initialLoad($routeParams.applicationId);

            $scope.closeQuickView = function () {
                $scope.quickView.show = false;
            };

            $scope.$on('$destroy', function () {
                jvHireBroadcastSVC.destroyAll();
            });
            //Adding event to handling Navigate away mesage while paginating between candidates
            var resetQuickFormDraftStatus = function () {
                $scope.flags.notes.inDraft = false;
                $scope.flags.messages.inDraft = false;
                $scope.flags.post.inDraft = false;
            };

            jvHireBroadcastSVC.subscribe('$locationChangeStart', function (evt, target) {
                if (target.indexOf($routeParams.applicationId) < 0) {
                    if ($scope.flags.notes.inDraft || $scope.flags.messages.inDraft || $scope.flags.post.inDraft) {
                        if (!window.confirm(i18n.NAV_AWAY_WARNING_MESSAGE + '\n\n' + i18n.NAV_AWAY_CONFIRM)) {
                            evt.preventDefault();
                            $rootScope.flags.loading = false;
                        } else {
                            resetQuickFormDraftStatus();
                        }
                    }
                }
            });

            $scope.showCandidateProfileBasedOnLiIntegration = function () {
                if (window.isApplyConnectProfileEnabled) {
                    $scope.showLinkedProfileIntegration = true;
                    $scope.liApplyConnectEnabled = true;
                    $scope.liRscEnabled = true;
                    $scope.loadLinkedinRscData(true, true);
                }
                else {
                    $scope.showLinkedProfileIntegration = true;
                    $scope.liApplyConnectEnabled = false;
                    $scope.liRscEnabled = true;
                    $scope.loadLinkedinRscData(false, true);
                }
            };
            var getApplicationSummary = function (applicationEId, fastRead) {
                jvCandidatesService.getApplicationSummary({
                    applicationEId: applicationEId,
                    readMode: fastRead.readMode
                }, function (data) {
                    //populate candidate details with already resolved candidate details
                    if (angular.isDefined($window.__applicationDetails.candidateDetails)) {
                        $scope.candidateDetails.onGetSuccess($window.__applicationDetails.candidateDetails);
                    }
                    if (angular.isDefined($window.__applicationDetails.workEducationData)) {
                        $scope.renderProfileData($window.__applicationDetails.workEducationData);
                    }
                    if ($scope.perms.APPLICATION_APPLICATIONS_APP_DETAILS_GET) {
                        $scope.applicationDetails.onGetSuccess(data);
                    }
                    if ($scope.perms.APPLICATION_SOURCES_GET) {
                        $scope.appSource.onFetchSuccess(data);
                    }
                    if ($scope.perms.APPLICATION_COLLECTION_GET) {
                        $scope.collections.postFetch(data);
                    }
                });
            };
            $scope.loadLinkedinRscData = function (isApplyConnectEnabled, isRscEnabled) {
                getApplicationSummary($routeParams.applicationId, $scope.pageReadMode());
                if ($scope.LIScriptCounter !== 0) {
                    return;
                }
                if ($scope.perms.APPLICATION_SHOW_CONTACT) {
                    $scope.fireSocialProfiles($scope.appDetails, isApplyConnectEnabled, isRscEnabled);
                }
            };
            $scope.pageReadMode = function (fastRead) {
                var mode = {};
                if (fastRead || $scope.readMode || $rootScope.fastRead.summary) {
                    mode.readMode = 0;
                    $scope.fastRead.summary = true;
                } else {
                    mode.readMode = 1;
                }
                return mode;
            };

            $scope.fireSocialProfiles = function (applicationObject, isApplyConnectEnabled, isRscEnabled) {
                if (applicationObject.application) {
                    candidates.getContactId(applicationObject.application.candidateEId, function (data) {
                        if (!$.isEmptyObject(data) && data.resultList) {
                            candidates.fetchSocialProfiles(data.resultList[0].EId);
                            //process to discover the linkedIn id.
                            var base = data.resultList[0];
                            applicationObject.application.candidate.linkedInId = base.linkedInId;
                            applicationObject.application.candidate.linkedInUrl = base.linkedInUrl;
                            applicationObject.application.candidate.noteId = base.linkedInInfoId;
                            applicationObject.application.candidate.contactEID = base.EId;
                            $scope.contactEId = base.EId;
                            if (isRscEnabled && isApplyConnectEnabled) {
                                var acUrl = $window.jvUrls.jhire + '/modules/candidates/LIAcFrame.html?applicationId=' + $scope.appDetails.application.EId + '&contactEid=' + base.EId;
                                $scope.liAcFrameurl = $sce.trustAsResourceUrl(acUrl);
                            }
                            else if (isRscEnabled) {
                                var url = $window.jvUrls.jhire + '/modules/candidates/LIRSCFrame.html?applicationId=' + $scope.appDetails.application.EId + '&contactEid=' + base.EId;
                                $scope.liRscFrameurl = $sce.trustAsResourceUrl(url);
                            }
                            $scope.linkedInSyncStatus();
                            //initialize the linkedin object
                            var linkedInObject = {};
                            linkedInObject.firstName = applicationObject.application.candidate.firstName;
                            linkedInObject.lastName = applicationObject.application.candidate.lastName;
                            linkedInObject.customerId = applicationObject.application.candidate.contactEID;
                            linkedInObject.id = applicationObject.application.candidate.linkedInId;
                            linkedInObject.emailAddress = applicationObject.application.candidate.email;
                            linkedInObject.companyName = applicationObject.application.candidate.company;
                            linkedInObject.title = applicationObject.application.candidate.title;
                            linkedInObject.location = applicationObject.application.candidate.postalCode;
                            linkedInObject.noteId = applicationObject.application.candidate.noteId;

                            $scope.fireLinkedIn(linkedInObject);
                        }
                    }, function (err) {
                        $log.error(err);
                    });
                    $scope.LIScriptCounter++;
                }
            };
            $scope.showLinkedInSyncErrorIcon = false;
            $scope.linkedInSyncStatus = function () {
                var contactId = $scope.contactEId;
                var applicationId = $scope.appDetails.application.EId;
                jvCandidatesService.getLinkedInCandidateSyncStatus({
                    contactEid: contactId,
                    applicationId: applicationId
                }, function (result) {
                    if (result) {
                        angular.forEach(result, function (syncDetails) {
                            if (syncDetails && syncDetails.syncStatus && syncDetails.type === 'LINKEDIN_ONE_CLICK_EXPORT') {
                                $scope.oneClickExportLastSyncDate = syncDetails.syncStatus.syncedOn;
                                $scope.showLinkedInSyncErrorIcon = !syncDetails.syncStatus.success;
                            }
                        });
                    }
                });
            };

            $scope.fireLinkedIn = function (applicationObject) {
                if ($window.LICSAKey && $scope.perms.APPLICATION_APPLICATIONS_LINKEDIN_PROFILE_GET) {
                    setTimeout(function () {
                        document.initLinkedIn($scope.appDetails.application.EId, null, $('#LinkedInIframe'), applicationObject, $window.LICSAKey);
                    }, 1000);
                }
            };

            $scope.refreshLinkedInSync = function () {
                var contactId = $scope.contactEId;
                var applicationId = $scope.appDetails.application.EId;
                jvCandidatesService.syncCandidateToLinkedIn({
                    contactEid: contactId,
                    applicationId: applicationId
                }, function (result) {
                    if (result) {
                        angular.forEach(result, function (syncDetails) {
                            if (syncDetails && syncDetails.syncStatus && syncDetails.type === 'LINKEDIN_ONE_CLICK_EXPORT') {
                                $scope.oneClickExportLastSyncDate = syncDetails.syncStatus.syncedOn;
                                $scope.showLinkedInSyncErrorIcon = !syncDetails.syncStatus.success;
                            }
                        });
                    }
                });
            };

            $scope.unlinkLinkedInProfile = function (memberToken, unlink) {
                var contactEid = $scope.contactEId;
                var applicationId = $scope.appDetails.application.EId;
                jvCandidatesService.unlinkLinkedInProfile({
                    contactEid: contactEid,
                    memberToken: memberToken,
                    unlink: unlink,
                    applicationId: applicationId
                });
            };

            $scope.hideLinkedinProfilePopup = function () {
                $scope.showLinkedProfileIntegration = false;
                $scope.liApplyConnectEnabled = false;
                $scope.liRscEnabled = false;
            };
        }
    ]);